//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface INotificationClient {
    dailyNotification(notificationFrequency: NotificationFrequency | undefined): Observable<Unit>;
    notifyNm(id: string | undefined, processName: string | null | undefined, userType: string | null | undefined, sourceIds: string[]): Observable<Unit>;
    illustrationNotification(illustrationId: string, emails: EmailContact): Observable<string>;
    allNotifications(): Observable<NotificationDto[]>;
    notificationsByCommentId(id: string): Observable<NotificationDto>;
    notificationsByNotificationType(notificationType: NotificationType, notificationFrequency: NotificationFrequency): Observable<NotificationDto[]>;
    saveNotification(notification: NotificationDto): Observable<string>;
    sendEmailNotification(emailMessage: EmailMessageDto): Observable<string>;
    sendMultipleEmailNotification(emailMessages: EmailMessageDto[]): Observable<string>;
    markNotificationsAsRead(command: UpdateEmailNotificationsStatusCommand): Observable<string>;
    updateNotificationStatusByCommentId(command: UpdateNotificationStatusByCommentIdCommand): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class NotificationClient implements INotificationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    dailyNotification(notificationFrequency: NotificationFrequency | undefined): Observable<Unit> {
        let url_ = this.baseUrl + "/api/Notification/dailyNotification?";
        if (notificationFrequency === null)
            throw new Error("The parameter 'notificationFrequency' cannot be null.");
        else if (notificationFrequency !== undefined)
            url_ += "notificationFrequency=" + encodeURIComponent("" + notificationFrequency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDailyNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDailyNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Unit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Unit>;
        }));
    }

    protected processDailyNotification(response: HttpResponseBase): Observable<Unit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    notifyNm(id: string | undefined, processName: string | null | undefined, userType: string | null | undefined, sourceIds: string[]): Observable<Unit> {
        let url_ = this.baseUrl + "/api/Notification/NotifyUsers?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (processName !== undefined && processName !== null)
            url_ += "processName=" + encodeURIComponent("" + processName) + "&";
        if (userType !== undefined && userType !== null)
            url_ += "userType=" + encodeURIComponent("" + userType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sourceIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyNm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyNm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Unit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Unit>;
        }));
    }

    protected processNotifyNm(response: HttpResponseBase): Observable<Unit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    illustrationNotification(illustrationId: string, emails: EmailContact): Observable<string> {
        let url_ = this.baseUrl + "/api/Notification/IllustrationNotification/{illustrationId}";
        if (illustrationId === undefined || illustrationId === null)
            throw new Error("The parameter 'illustrationId' must be defined.");
        url_ = url_.replace("{illustrationId}", encodeURIComponent("" + illustrationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emails);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIllustrationNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIllustrationNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processIllustrationNotification(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    allNotifications(): Observable<NotificationDto[]> {
        let url_ = this.baseUrl + "/api/Notification/AllNotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAllNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationDto[]>;
        }));
    }

    protected processAllNotifications(response: HttpResponseBase): Observable<NotificationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    notificationsByCommentId(id: string): Observable<NotificationDto> {
        let url_ = this.baseUrl + "/api/Notification/Notifications/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationsByCommentId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationsByCommentId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationDto>;
        }));
    }

    protected processNotificationsByCommentId(response: HttpResponseBase): Observable<NotificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    notificationsByNotificationType(notificationType: NotificationType, notificationFrequency: NotificationFrequency): Observable<NotificationDto[]> {
        let url_ = this.baseUrl + "/api/Notification/NotificationsByType/{notificationType}/{notificationFrequency}";
        if (notificationType === undefined || notificationType === null)
            throw new Error("The parameter 'notificationType' must be defined.");
        url_ = url_.replace("{notificationType}", encodeURIComponent("" + notificationType));
        if (notificationFrequency === undefined || notificationFrequency === null)
            throw new Error("The parameter 'notificationFrequency' must be defined.");
        url_ = url_.replace("{notificationFrequency}", encodeURIComponent("" + notificationFrequency));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationsByNotificationType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationsByNotificationType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationDto[]>;
        }));
    }

    protected processNotificationsByNotificationType(response: HttpResponseBase): Observable<NotificationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveNotification(notification: NotificationDto): Observable<string> {
        let url_ = this.baseUrl + "/api/Notification/SaveNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notification);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveNotification(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendEmailNotification(emailMessage: EmailMessageDto): Observable<string> {
        let url_ = this.baseUrl + "/api/Notification/SendEmailNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailMessage);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmailNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSendEmailNotification(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendMultipleEmailNotification(emailMessages: EmailMessageDto[]): Observable<string> {
        let url_ = this.baseUrl + "/api/Notification/SendMultipleEmailNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailMessages);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMultipleEmailNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMultipleEmailNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSendMultipleEmailNotification(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    markNotificationsAsRead(command: UpdateEmailNotificationsStatusCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Notification/UpdateEmailNotificationsStatusAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkNotificationsAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkNotificationsAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processMarkNotificationsAsRead(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateNotificationStatusByCommentId(command: UpdateNotificationStatusByCommentIdCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Notification/UpdateNotificationStatusByCommentId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNotificationStatusByCommentId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNotificationStatusByCommentId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateNotificationStatusByCommentId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUsersClient {
    getUsers(pageNumber: number | undefined, pageSize: number | undefined): Observable<UserDto[]>;
    upsertUser(command: UpsertUserCommand): Observable<string>;
    getUsersByNetworkMemberId(networkMemberId: string | null | undefined): Observable<UserDto[]>;
    getUsersByConnectedNetworkMemberId(): Observable<UserDto[]>;
    getUserById(id: string): Observable<UserDto>;
    getUserByEmail(email: string | null): Observable<UserDto>;
    getUserByIdByNM(id: string, nmIds: string[] | null | undefined): Observable<UserDto>;
    getCurrentUser(): Observable<UserDto>;
    updateUserConsents(command: UpdateUserConsentsCommand): Observable<number>;
    getAllUsers(): Observable<UserDto[]>;
    getAllSubscribeUsers(email: string | null | undefined): Observable<UserDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class UsersClient implements IUsersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getUsers(pageNumber: number | undefined, pageSize: number | undefined): Observable<UserDto[]> {
        let url_ = this.baseUrl + "/api/Users?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto[]>;
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<UserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    upsertUser(command: UpsertUserCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpsertUser(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUsersByNetworkMemberId(networkMemberId: string | null | undefined): Observable<UserDto[]> {
        let url_ = this.baseUrl + "/api/Users/user/getUsersByNetworkMemberId?";
        if (networkMemberId !== undefined && networkMemberId !== null)
            url_ += "networkMemberId=" + encodeURIComponent("" + networkMemberId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersByNetworkMemberId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersByNetworkMemberId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto[]>;
        }));
    }

    protected processGetUsersByNetworkMemberId(response: HttpResponseBase): Observable<UserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUsersByConnectedNetworkMemberId(): Observable<UserDto[]> {
        let url_ = this.baseUrl + "/api/Users/user/getUsersByConnectedNetworkMemberId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersByConnectedNetworkMemberId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersByConnectedNetworkMemberId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto[]>;
        }));
    }

    protected processGetUsersByConnectedNetworkMemberId(response: HttpResponseBase): Observable<UserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserById(id: string): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/Users/user/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGetUserById(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserByEmail(email: string | null): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/Users/user/getUserByEmail/{email}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserByEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGetUserByEmail(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserByIdByNM(id: string, nmIds: string[] | null | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/Users/userByNM/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (nmIds !== undefined && nmIds !== null)
            nmIds && nmIds.forEach(item => { url_ += "nmIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserByIdByNM(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserByIdByNM(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGetUserByIdByNM(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCurrentUser(): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/Users/Me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGetCurrentUser(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUserConsents(command: UpdateUserConsentsCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Users/updateConsents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserConsents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserConsents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateUserConsents(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllUsers(): Observable<UserDto[]> {
        let url_ = this.baseUrl + "/api/Users/All";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto[]>;
        }));
    }

    protected processGetAllUsers(response: HttpResponseBase): Observable<UserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllSubscribeUsers(email: string | null | undefined): Observable<UserDto[]> {
        let url_ = this.baseUrl + "/api/Users/getAllSubscribeUsers?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSubscribeUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSubscribeUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto[]>;
        }));
    }

    protected processGetAllSubscribeUsers(response: HttpResponseBase): Observable<UserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAccountsClient {
    getAccountById(id: string | null): Observable<AccountDto>;
    findAccountsByName(name: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<AccountDto[]>;
    findAccountsByState(state: string | null | undefined, name: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<AccountDto[]>;
    findAccountByName(clientId: string | null | undefined, clientName: string | null | undefined): Observable<AccountDto>;
    findAccountXesByName(name: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<AccountDto[]>;
    findPooledAndProspectAccountsByName(name: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<AccountDto[]>;
    getTechnicalContactByExternalAccountNumber(externalAccountNumber: string | null | undefined): Observable<TechnicalContact>;
    getAccountExcelFile(externalAccountNumber: string | null | undefined): Observable<FileResponse>;
    getAccountExpansionPlan(accountId: string | undefined, sortOrder: string | null | undefined, sortColumn: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PaginatedListOfExpansionPlanDto>;
}

@Injectable({
    providedIn: 'root'
})
export class AccountsClient implements IAccountsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAccountById(id: string | null): Observable<AccountDto> {
        let url_ = this.baseUrl + "/api/Accounts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountDto>;
        }));
    }

    protected processGetAccountById(response: HttpResponseBase): Observable<AccountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    findAccountsByName(name: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<AccountDto[]> {
        let url_ = this.baseUrl + "/api/Accounts/filter?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindAccountsByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindAccountsByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountDto[]>;
        }));
    }

    protected processFindAccountsByName(response: HttpResponseBase): Observable<AccountDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    findAccountsByState(state: string | null | undefined, name: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<AccountDto[]> {
        let url_ = this.baseUrl + "/api/Accounts/filterByState?";
        if (state !== undefined && state !== null)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindAccountsByState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindAccountsByState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountDto[]>;
        }));
    }

    protected processFindAccountsByState(response: HttpResponseBase): Observable<AccountDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    findAccountByName(clientId: string | null | undefined, clientName: string | null | undefined): Observable<AccountDto> {
        let url_ = this.baseUrl + "/api/Accounts/findAccountByName?";
        if (clientId !== undefined && clientId !== null)
            url_ += "ClientId=" + encodeURIComponent("" + clientId) + "&";
        if (clientName !== undefined && clientName !== null)
            url_ += "ClientName=" + encodeURIComponent("" + clientName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindAccountByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindAccountByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountDto>;
        }));
    }

    protected processFindAccountByName(response: HttpResponseBase): Observable<AccountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    findAccountXesByName(name: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<AccountDto[]> {
        let url_ = this.baseUrl + "/api/Accounts/filter/extended?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindAccountXesByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindAccountXesByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountDto[]>;
        }));
    }

    protected processFindAccountXesByName(response: HttpResponseBase): Observable<AccountDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    findPooledAndProspectAccountsByName(name: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<AccountDto[]> {
        let url_ = this.baseUrl + "/api/Accounts/pooledandprospect/filter?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindPooledAndProspectAccountsByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindPooledAndProspectAccountsByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountDto[]>;
        }));
    }

    protected processFindPooledAndProspectAccountsByName(response: HttpResponseBase): Observable<AccountDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTechnicalContactByExternalAccountNumber(externalAccountNumber: string | null | undefined): Observable<TechnicalContact> {
        let url_ = this.baseUrl + "/api/Accounts/technicalaccount?";
        if (externalAccountNumber !== undefined && externalAccountNumber !== null)
            url_ += "ExternalAccountNumber=" + encodeURIComponent("" + externalAccountNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTechnicalContactByExternalAccountNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTechnicalContactByExternalAccountNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TechnicalContact>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TechnicalContact>;
        }));
    }

    protected processGetTechnicalContactByExternalAccountNumber(response: HttpResponseBase): Observable<TechnicalContact> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TechnicalContact.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAccountExcelFile(externalAccountNumber: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Accounts/excel?";
        if (externalAccountNumber !== undefined && externalAccountNumber !== null)
            url_ += "ExternalAccountNumber=" + encodeURIComponent("" + externalAccountNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountExcelFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountExcelFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetAccountExcelFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAccountExpansionPlan(accountId: string | undefined, sortOrder: string | null | undefined, sortColumn: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<PaginatedListOfExpansionPlanDto> {
        let url_ = this.baseUrl + "/api/Accounts/expansionPlan?";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountExpansionPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountExpansionPlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedListOfExpansionPlanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedListOfExpansionPlanDto>;
        }));
    }

    protected processGetAccountExpansionPlan(response: HttpResponseBase): Observable<PaginatedListOfExpansionPlanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfExpansionPlanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBooleanTaskClient {
    getMyOrganization(filterParameter_Id: string | undefined, filterParameter_SourceId: string | null | undefined, filterParameter_Title: string | null | undefined, filterParameter_SubTitle: string | null | undefined, filterParameter_DisplayDate: Date | undefined, filterParameter_ProcessId: string | null | undefined, filterParameter_NetworkMemberId: string | null | undefined, filterParameter_ClientId: string | null | undefined, filterParameter_Country: string | null | undefined, filterParameter_Status: TasksStatus | null | undefined, filterParameter_ClientName: string | null | undefined, filterParameter_NetworkMemberIds: string[] | null | undefined, filterParameter_SubscriberId: string | null | undefined, filterParameter_SearchDateLimit: Date | null | undefined, filterParameter_OverdueDate: number | null | undefined, filterParameter_ModifiedDate: Date | null | undefined, filterParameter_PayTo: PayToEnum | null | undefined, sortingElements: SortingElement[] | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<BooleanTaskDto[]>;
    getBooleanTaskById(taskId: string): Observable<BooleanTaskDto>;
    getTasks(filterParameter_Id: string | undefined, filterParameter_SourceId: string | null | undefined, filterParameter_Title: string | null | undefined, filterParameter_SubTitle: string | null | undefined, filterParameter_DisplayDate: Date | undefined, filterParameter_ProcessId: string | null | undefined, filterParameter_NetworkMemberId: string | null | undefined, filterParameter_ClientId: string | null | undefined, filterParameter_Country: string | null | undefined, filterParameter_Status: TasksStatus | null | undefined, filterParameter_ClientName: string | null | undefined, filterParameter_NetworkMemberIds: string[] | null | undefined, filterParameter_SubscriberId: string | null | undefined, filterParameter_SearchDateLimit: Date | null | undefined, filterParameter_OverdueDate: number | null | undefined, filterParameter_ModifiedDate: Date | null | undefined, filterParameter_PayTo: PayToEnum | null | undefined, sortingElements: SortingElement[] | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<BooleanTaskDto[]>;
    upsert(request: UpsertBooleanTaskDto): Observable<string>;
    batchUpsert(tasks: UpsertBooleanTaskDto[]): Observable<string>;
    update(request: UpdateBooleanTaskDto): Observable<string | null>;
    downloadFile(taskId: string | undefined, fileId: string | undefined): Observable<string>;
    downloadFileFromPath(taskId: string | undefined, attachmentPath: string | null | undefined): Observable<string>;
    getTaskSubscribersByTaskId(taskId: string): Observable<TaskSubscribersDto>;
    changeTaskStatus(id: string | undefined, status: TasksStatus | undefined): Observable<Unit>;
}

@Injectable({
    providedIn: 'root'
})
export class BooleanTaskClient implements IBooleanTaskClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getMyOrganization(filterParameter_Id: string | undefined, filterParameter_SourceId: string | null | undefined, filterParameter_Title: string | null | undefined, filterParameter_SubTitle: string | null | undefined, filterParameter_DisplayDate: Date | undefined, filterParameter_ProcessId: string | null | undefined, filterParameter_NetworkMemberId: string | null | undefined, filterParameter_ClientId: string | null | undefined, filterParameter_Country: string | null | undefined, filterParameter_Status: TasksStatus | null | undefined, filterParameter_ClientName: string | null | undefined, filterParameter_NetworkMemberIds: string[] | null | undefined, filterParameter_SubscriberId: string | null | undefined, filterParameter_SearchDateLimit: Date | null | undefined, filterParameter_OverdueDate: number | null | undefined, filterParameter_ModifiedDate: Date | null | undefined, filterParameter_PayTo: PayToEnum | null | undefined, sortingElements: SortingElement[] | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<BooleanTaskDto[]> {
        let url_ = this.baseUrl + "/api/BooleanTask/myOrganization?";
        if (filterParameter_Id === null)
            throw new Error("The parameter 'filterParameter_Id' cannot be null.");
        else if (filterParameter_Id !== undefined)
            url_ += "FilterParameter.Id=" + encodeURIComponent("" + filterParameter_Id) + "&";
        if (filterParameter_SourceId !== undefined && filterParameter_SourceId !== null)
            url_ += "FilterParameter.SourceId=" + encodeURIComponent("" + filterParameter_SourceId) + "&";
        if (filterParameter_Title !== undefined && filterParameter_Title !== null)
            url_ += "FilterParameter.Title=" + encodeURIComponent("" + filterParameter_Title) + "&";
        if (filterParameter_SubTitle !== undefined && filterParameter_SubTitle !== null)
            url_ += "FilterParameter.SubTitle=" + encodeURIComponent("" + filterParameter_SubTitle) + "&";
        if (filterParameter_DisplayDate === null)
            throw new Error("The parameter 'filterParameter_DisplayDate' cannot be null.");
        else if (filterParameter_DisplayDate !== undefined)
            url_ += "FilterParameter.DisplayDate=" + encodeURIComponent(filterParameter_DisplayDate ? "" + filterParameter_DisplayDate.toISOString() : "") + "&";
        if (filterParameter_ProcessId !== undefined && filterParameter_ProcessId !== null)
            url_ += "FilterParameter.ProcessId=" + encodeURIComponent("" + filterParameter_ProcessId) + "&";
        if (filterParameter_NetworkMemberId !== undefined && filterParameter_NetworkMemberId !== null)
            url_ += "FilterParameter.NetworkMemberId=" + encodeURIComponent("" + filterParameter_NetworkMemberId) + "&";
        if (filterParameter_ClientId !== undefined && filterParameter_ClientId !== null)
            url_ += "FilterParameter.ClientId=" + encodeURIComponent("" + filterParameter_ClientId) + "&";
        if (filterParameter_Country !== undefined && filterParameter_Country !== null)
            url_ += "FilterParameter.Country=" + encodeURIComponent("" + filterParameter_Country) + "&";
        if (filterParameter_Status !== undefined && filterParameter_Status !== null)
            url_ += "FilterParameter.Status=" + encodeURIComponent("" + filterParameter_Status) + "&";
        if (filterParameter_ClientName !== undefined && filterParameter_ClientName !== null)
            url_ += "FilterParameter.ClientName=" + encodeURIComponent("" + filterParameter_ClientName) + "&";
        if (filterParameter_NetworkMemberIds !== undefined && filterParameter_NetworkMemberIds !== null)
            filterParameter_NetworkMemberIds && filterParameter_NetworkMemberIds.forEach(item => { url_ += "FilterParameter.NetworkMemberIds=" + encodeURIComponent("" + item) + "&"; });
        if (filterParameter_SubscriberId !== undefined && filterParameter_SubscriberId !== null)
            url_ += "FilterParameter.SubscriberId=" + encodeURIComponent("" + filterParameter_SubscriberId) + "&";
        if (filterParameter_SearchDateLimit !== undefined && filterParameter_SearchDateLimit !== null)
            url_ += "FilterParameter.SearchDateLimit=" + encodeURIComponent(filterParameter_SearchDateLimit ? "" + filterParameter_SearchDateLimit.toISOString() : "") + "&";
        if (filterParameter_OverdueDate !== undefined && filterParameter_OverdueDate !== null)
            url_ += "FilterParameter.OverdueDate=" + encodeURIComponent("" + filterParameter_OverdueDate) + "&";
        if (filterParameter_ModifiedDate !== undefined && filterParameter_ModifiedDate !== null)
            url_ += "FilterParameter.ModifiedDate=" + encodeURIComponent(filterParameter_ModifiedDate ? "" + filterParameter_ModifiedDate.toISOString() : "") + "&";
        if (filterParameter_PayTo !== undefined && filterParameter_PayTo !== null)
            url_ += "FilterParameter.PayTo=" + encodeURIComponent("" + filterParameter_PayTo) + "&";
        if (sortingElements !== undefined && sortingElements !== null)
            sortingElements && sortingElements.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortingElements[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanTaskDto[]>;
        }));
    }

    protected processGetMyOrganization(response: HttpResponseBase): Observable<BooleanTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BooleanTaskDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBooleanTaskById(taskId: string): Observable<BooleanTaskDto> {
        let url_ = this.baseUrl + "/api/BooleanTask/{taskId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBooleanTaskById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBooleanTaskById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanTaskDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanTaskDto>;
        }));
    }

    protected processGetBooleanTaskById(response: HttpResponseBase): Observable<BooleanTaskDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanTaskDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTasks(filterParameter_Id: string | undefined, filterParameter_SourceId: string | null | undefined, filterParameter_Title: string | null | undefined, filterParameter_SubTitle: string | null | undefined, filterParameter_DisplayDate: Date | undefined, filterParameter_ProcessId: string | null | undefined, filterParameter_NetworkMemberId: string | null | undefined, filterParameter_ClientId: string | null | undefined, filterParameter_Country: string | null | undefined, filterParameter_Status: TasksStatus | null | undefined, filterParameter_ClientName: string | null | undefined, filterParameter_NetworkMemberIds: string[] | null | undefined, filterParameter_SubscriberId: string | null | undefined, filterParameter_SearchDateLimit: Date | null | undefined, filterParameter_OverdueDate: number | null | undefined, filterParameter_ModifiedDate: Date | null | undefined, filterParameter_PayTo: PayToEnum | null | undefined, sortingElements: SortingElement[] | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<BooleanTaskDto[]> {
        let url_ = this.baseUrl + "/api/BooleanTask/filter?";
        if (filterParameter_Id === null)
            throw new Error("The parameter 'filterParameter_Id' cannot be null.");
        else if (filterParameter_Id !== undefined)
            url_ += "FilterParameter.Id=" + encodeURIComponent("" + filterParameter_Id) + "&";
        if (filterParameter_SourceId !== undefined && filterParameter_SourceId !== null)
            url_ += "FilterParameter.SourceId=" + encodeURIComponent("" + filterParameter_SourceId) + "&";
        if (filterParameter_Title !== undefined && filterParameter_Title !== null)
            url_ += "FilterParameter.Title=" + encodeURIComponent("" + filterParameter_Title) + "&";
        if (filterParameter_SubTitle !== undefined && filterParameter_SubTitle !== null)
            url_ += "FilterParameter.SubTitle=" + encodeURIComponent("" + filterParameter_SubTitle) + "&";
        if (filterParameter_DisplayDate === null)
            throw new Error("The parameter 'filterParameter_DisplayDate' cannot be null.");
        else if (filterParameter_DisplayDate !== undefined)
            url_ += "FilterParameter.DisplayDate=" + encodeURIComponent(filterParameter_DisplayDate ? "" + filterParameter_DisplayDate.toISOString() : "") + "&";
        if (filterParameter_ProcessId !== undefined && filterParameter_ProcessId !== null)
            url_ += "FilterParameter.ProcessId=" + encodeURIComponent("" + filterParameter_ProcessId) + "&";
        if (filterParameter_NetworkMemberId !== undefined && filterParameter_NetworkMemberId !== null)
            url_ += "FilterParameter.NetworkMemberId=" + encodeURIComponent("" + filterParameter_NetworkMemberId) + "&";
        if (filterParameter_ClientId !== undefined && filterParameter_ClientId !== null)
            url_ += "FilterParameter.ClientId=" + encodeURIComponent("" + filterParameter_ClientId) + "&";
        if (filterParameter_Country !== undefined && filterParameter_Country !== null)
            url_ += "FilterParameter.Country=" + encodeURIComponent("" + filterParameter_Country) + "&";
        if (filterParameter_Status !== undefined && filterParameter_Status !== null)
            url_ += "FilterParameter.Status=" + encodeURIComponent("" + filterParameter_Status) + "&";
        if (filterParameter_ClientName !== undefined && filterParameter_ClientName !== null)
            url_ += "FilterParameter.ClientName=" + encodeURIComponent("" + filterParameter_ClientName) + "&";
        if (filterParameter_NetworkMemberIds !== undefined && filterParameter_NetworkMemberIds !== null)
            filterParameter_NetworkMemberIds && filterParameter_NetworkMemberIds.forEach(item => { url_ += "FilterParameter.NetworkMemberIds=" + encodeURIComponent("" + item) + "&"; });
        if (filterParameter_SubscriberId !== undefined && filterParameter_SubscriberId !== null)
            url_ += "FilterParameter.SubscriberId=" + encodeURIComponent("" + filterParameter_SubscriberId) + "&";
        if (filterParameter_SearchDateLimit !== undefined && filterParameter_SearchDateLimit !== null)
            url_ += "FilterParameter.SearchDateLimit=" + encodeURIComponent(filterParameter_SearchDateLimit ? "" + filterParameter_SearchDateLimit.toISOString() : "") + "&";
        if (filterParameter_OverdueDate !== undefined && filterParameter_OverdueDate !== null)
            url_ += "FilterParameter.OverdueDate=" + encodeURIComponent("" + filterParameter_OverdueDate) + "&";
        if (filterParameter_ModifiedDate !== undefined && filterParameter_ModifiedDate !== null)
            url_ += "FilterParameter.ModifiedDate=" + encodeURIComponent(filterParameter_ModifiedDate ? "" + filterParameter_ModifiedDate.toISOString() : "") + "&";
        if (filterParameter_PayTo !== undefined && filterParameter_PayTo !== null)
            url_ += "FilterParameter.PayTo=" + encodeURIComponent("" + filterParameter_PayTo) + "&";
        if (sortingElements !== undefined && sortingElements !== null)
            sortingElements && sortingElements.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortingElements[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanTaskDto[]>;
        }));
    }

    protected processGetTasks(response: HttpResponseBase): Observable<BooleanTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BooleanTaskDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    upsert(request: UpsertBooleanTaskDto): Observable<string> {
        let url_ = this.baseUrl + "/api/BooleanTask/upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    batchUpsert(tasks: UpsertBooleanTaskDto[]): Observable<string> {
        let url_ = this.baseUrl + "/api/BooleanTask/batchupsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tasks);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatchUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchUpsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBatchUpsert(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(request: UpdateBooleanTaskDto): Observable<string | null> {
        let url_ = this.baseUrl + "/api/BooleanTask/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadFile(taskId: string | undefined, fileId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/BooleanTask/Download?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadFileFromPath(taskId: string | undefined, attachmentPath: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/BooleanTask/DownloadFromPath?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (attachmentPath !== undefined && attachmentPath !== null)
            url_ += "AttachmentPath=" + encodeURIComponent("" + attachmentPath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFileFromPath(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFileFromPath(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDownloadFileFromPath(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTaskSubscribersByTaskId(taskId: string): Observable<TaskSubscribersDto> {
        let url_ = this.baseUrl + "/api/BooleanTask/{taskId}/tasksubscribers";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskSubscribersByTaskId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskSubscribersByTaskId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskSubscribersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskSubscribersDto>;
        }));
    }

    protected processGetTaskSubscribersByTaskId(response: HttpResponseBase): Observable<TaskSubscribersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskSubscribersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeTaskStatus(id: string | undefined, status: TasksStatus | undefined): Observable<Unit> {
        let url_ = this.baseUrl + "/api/BooleanTask/updateTaskStatus?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeTaskStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeTaskStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Unit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Unit>;
        }));
    }

    protected processChangeTaskStatus(response: HttpResponseBase): Observable<Unit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICommentsClient {
    create(taskId: string, customSubscriberProvider: string | null | undefined, processName: string | null | undefined, clientName: string | null | undefined, networkMemberName: string | null | undefined, country: string | null | undefined, periodEnd: string | null | undefined, files: FileParameter[] | null | undefined, content: string | null | undefined, tags: string[] | null | undefined, isDeleted: boolean | undefined, isEdited: boolean | undefined, isHtmlText: boolean | undefined, commentType: CommentType | null | undefined, notificationFrequency: NotificationFrequency | undefined, notificationType: NotificationType | undefined, notificationStatus: NotificationStatus | undefined): Observable<CommentDto>;
    get(taskId: string): Observable<DiscussionDto>;
    getDiscussionTaskSubscribers(discussionId: string): Observable<TaskSubscribersDto>;
    getIllustrationTaskSubscribers(discussionId: string | undefined, clientSubscribers: TaskUserSusbscriptionDto[] | null | undefined, insuropeSubscribers: TaskUserSusbscriptionDto[] | null | undefined, networkMemberSubscribers: TaskUserSusbscriptionDto[] | null | undefined): Observable<TaskSubscribersDto>;
    delete(taskId: string | undefined, commentId: string | undefined): Observable<Unit>;
    downloadFile(commentId: string | undefined, discussionId: string | undefined, fileId: string | undefined): Observable<string>;
    update(taskId: string | undefined, lastExported: Date | undefined): Observable<Unit>;
    addCurrentUserToSubscribers(taskId: string): Observable<TaskSubscribersDto>;
    addSubscriber(taskId: string | undefined, subscriberId: string | undefined, processId: string | null | undefined): Observable<TaskSubscribersDto>;
    deleteSubscriber(taskId: string | undefined, userId: string | undefined): Observable<TaskSubscribersDto>;
    getAllAttachments(discussionId: string): Observable<AttachmentDTO[]>;
    addCommentTags(tagNames: string[] | null | undefined, taskId: string | undefined, commentId: string | undefined): Observable<CommentTagDto[]>;
    deleteCommentTags(tagId: string | undefined, taskId: string | undefined, commentId: string | undefined): Observable<Unit>;
    getCommentTags(taskId: string | undefined, commentId: string | undefined): Observable<CommentTagDto[]>;
    getDefaultTags(): Observable<CommentTagDto[]>;
    upsertDefaultTag(tagName: string | null | undefined): Observable<CommentTagDto>;
    getDiscussionTags(taskId: string | undefined, tagName: string | null | undefined): Observable<CommentTagDto[]>;
    filterCommentsByTag(taskId: string | undefined, name: string | null | undefined): Observable<CommentDto[]>;
    editComment(taskId: string | undefined, commentId: string | undefined, content: string | null | undefined, sendNotification: boolean | undefined, periodEnd: string | null | undefined, processName: string | null | undefined, clientName: string | null | undefined, networkMemberName: string | null | undefined, customSubscriberProvider: string | null | undefined, country: string | null | undefined, title: string | null | undefined, files: FileParameter[] | null | undefined): Observable<CommentDto>;
    addExternalComment(externalComment: AddExternalCommentsCommand): Observable<CommentDto[]>;
    deleteFileFromComment(taskId: string | undefined, fileId: string | undefined): Observable<Unit>;
}

@Injectable({
    providedIn: 'root'
})
export class CommentsClient implements ICommentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    create(taskId: string, customSubscriberProvider: string | null | undefined, processName: string | null | undefined, clientName: string | null | undefined, networkMemberName: string | null | undefined, country: string | null | undefined, periodEnd: string | null | undefined, files: FileParameter[] | null | undefined, content: string | null | undefined, tags: string[] | null | undefined, isDeleted: boolean | undefined, isEdited: boolean | undefined, isHtmlText: boolean | undefined, commentType: CommentType | null | undefined, notificationFrequency: NotificationFrequency | undefined, notificationType: NotificationType | undefined, notificationStatus: NotificationStatus | undefined): Observable<CommentDto> {
        let url_ = this.baseUrl + "/api/Comments/{taskId}?";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (customSubscriberProvider !== undefined && customSubscriberProvider !== null)
            url_ += "customSubscriberProvider=" + encodeURIComponent("" + customSubscriberProvider) + "&";
        if (processName !== undefined && processName !== null)
            url_ += "processName=" + encodeURIComponent("" + processName) + "&";
        if (clientName !== undefined && clientName !== null)
            url_ += "clientName=" + encodeURIComponent("" + clientName) + "&";
        if (networkMemberName !== undefined && networkMemberName !== null)
            url_ += "networkMemberName=" + encodeURIComponent("" + networkMemberName) + "&";
        if (country !== undefined && country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        if (periodEnd !== undefined && periodEnd !== null)
            url_ += "periodEnd=" + encodeURIComponent("" + periodEnd) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (content !== null && content !== undefined)
            content_.append("Content", content.toString());
        if (tags !== null && tags !== undefined)
            tags.forEach(item_ => content_.append("Tags", item_.toString()));
        if (isDeleted === null || isDeleted === undefined)
            throw new Error("The parameter 'isDeleted' cannot be null.");
        else
            content_.append("IsDeleted", isDeleted.toString());
        if (isEdited === null || isEdited === undefined)
            throw new Error("The parameter 'isEdited' cannot be null.");
        else
            content_.append("IsEdited", isEdited.toString());
        if (isHtmlText === null || isHtmlText === undefined)
            throw new Error("The parameter 'isHtmlText' cannot be null.");
        else
            content_.append("IsHtmlText", isHtmlText.toString());
        if (commentType !== null && commentType !== undefined)
            content_.append("CommentType", commentType.toString());
        if (notificationFrequency === null || notificationFrequency === undefined)
            throw new Error("The parameter 'notificationFrequency' cannot be null.");
        else
            content_.append("NotificationFrequency", notificationFrequency.toString());
        if (notificationType === null || notificationType === undefined)
            throw new Error("The parameter 'notificationType' cannot be null.");
        else
            content_.append("NotificationType", notificationType.toString());
        if (notificationStatus === null || notificationStatus === undefined)
            throw new Error("The parameter 'notificationStatus' cannot be null.");
        else
            content_.append("NotificationStatus", notificationStatus.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CommentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(taskId: string): Observable<DiscussionDto> {
        let url_ = this.baseUrl + "/api/Comments/{taskId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiscussionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiscussionDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DiscussionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiscussionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDiscussionTaskSubscribers(discussionId: string): Observable<TaskSubscribersDto> {
        let url_ = this.baseUrl + "/api/Comments/{discussionId}/tasksubscribers";
        if (discussionId === undefined || discussionId === null)
            throw new Error("The parameter 'discussionId' must be defined.");
        url_ = url_.replace("{discussionId}", encodeURIComponent("" + discussionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiscussionTaskSubscribers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiscussionTaskSubscribers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskSubscribersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskSubscribersDto>;
        }));
    }

    protected processGetDiscussionTaskSubscribers(response: HttpResponseBase): Observable<TaskSubscribersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskSubscribersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getIllustrationTaskSubscribers(discussionId: string | undefined, clientSubscribers: TaskUserSusbscriptionDto[] | null | undefined, insuropeSubscribers: TaskUserSusbscriptionDto[] | null | undefined, networkMemberSubscribers: TaskUserSusbscriptionDto[] | null | undefined): Observable<TaskSubscribersDto> {
        let url_ = this.baseUrl + "/api/Comments/illustrationTasksubscribers?";
        if (discussionId === null)
            throw new Error("The parameter 'discussionId' cannot be null.");
        else if (discussionId !== undefined)
            url_ += "DiscussionId=" + encodeURIComponent("" + discussionId) + "&";
        if (clientSubscribers !== undefined && clientSubscribers !== null)
            clientSubscribers && clientSubscribers.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "ClientSubscribers[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (insuropeSubscribers !== undefined && insuropeSubscribers !== null)
            insuropeSubscribers && insuropeSubscribers.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "InsuropeSubscribers[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (networkMemberSubscribers !== undefined && networkMemberSubscribers !== null)
            networkMemberSubscribers && networkMemberSubscribers.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "NetworkMemberSubscribers[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIllustrationTaskSubscribers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIllustrationTaskSubscribers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskSubscribersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskSubscribersDto>;
        }));
    }

    protected processGetIllustrationTaskSubscribers(response: HttpResponseBase): Observable<TaskSubscribersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskSubscribersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(taskId: string | undefined, commentId: string | undefined): Observable<Unit> {
        let url_ = this.baseUrl + "/api/Comments?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (commentId === null)
            throw new Error("The parameter 'commentId' cannot be null.");
        else if (commentId !== undefined)
            url_ += "commentId=" + encodeURIComponent("" + commentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Unit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Unit>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<Unit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadFile(commentId: string | undefined, discussionId: string | undefined, fileId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Comments/Download?";
        if (commentId === null)
            throw new Error("The parameter 'commentId' cannot be null.");
        else if (commentId !== undefined)
            url_ += "CommentId=" + encodeURIComponent("" + commentId) + "&";
        if (discussionId === null)
            throw new Error("The parameter 'discussionId' cannot be null.");
        else if (discussionId !== undefined)
            url_ += "DiscussionId=" + encodeURIComponent("" + discussionId) + "&";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(taskId: string | undefined, lastExported: Date | undefined): Observable<Unit> {
        let url_ = this.baseUrl + "/api/Comments/update?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (lastExported === null)
            throw new Error("The parameter 'lastExported' cannot be null.");
        else if (lastExported !== undefined)
            url_ += "LastExported=" + encodeURIComponent(lastExported ? "" + lastExported.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Unit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Unit>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<Unit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addCurrentUserToSubscribers(taskId: string): Observable<TaskSubscribersDto> {
        let url_ = this.baseUrl + "/api/Comments/addCurrentUserToSubscriber/{taskId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCurrentUserToSubscribers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCurrentUserToSubscribers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskSubscribersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskSubscribersDto>;
        }));
    }

    protected processAddCurrentUserToSubscribers(response: HttpResponseBase): Observable<TaskSubscribersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskSubscribersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addSubscriber(taskId: string | undefined, subscriberId: string | undefined, processId: string | null | undefined): Observable<TaskSubscribersDto> {
        let url_ = this.baseUrl + "/api/Comments/addSubscriber?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (subscriberId === null)
            throw new Error("The parameter 'subscriberId' cannot be null.");
        else if (subscriberId !== undefined)
            url_ += "SubscriberId=" + encodeURIComponent("" + subscriberId) + "&";
        if (processId !== undefined && processId !== null)
            url_ += "ProcessId=" + encodeURIComponent("" + processId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddSubscriber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddSubscriber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskSubscribersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskSubscribersDto>;
        }));
    }

    protected processAddSubscriber(response: HttpResponseBase): Observable<TaskSubscribersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskSubscribersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSubscriber(taskId: string | undefined, userId: string | undefined): Observable<TaskSubscribersDto> {
        let url_ = this.baseUrl + "/api/Comments/deleteSubscriber?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSubscriber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSubscriber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskSubscribersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskSubscribersDto>;
        }));
    }

    protected processDeleteSubscriber(response: HttpResponseBase): Observable<TaskSubscribersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskSubscribersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllAttachments(discussionId: string): Observable<AttachmentDTO[]> {
        let url_ = this.baseUrl + "/api/Comments/{discussionId}/allAttchments";
        if (discussionId === undefined || discussionId === null)
            throw new Error("The parameter 'discussionId' must be defined.");
        url_ = url_.replace("{discussionId}", encodeURIComponent("" + discussionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAttachments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAttachments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttachmentDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttachmentDTO[]>;
        }));
    }

    protected processGetAllAttachments(response: HttpResponseBase): Observable<AttachmentDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addCommentTags(tagNames: string[] | null | undefined, taskId: string | undefined, commentId: string | undefined): Observable<CommentTagDto[]> {
        let url_ = this.baseUrl + "/api/Comments/addTagsToComment?";
        if (tagNames !== undefined && tagNames !== null)
            tagNames && tagNames.forEach(item => { url_ += "TagNames=" + encodeURIComponent("" + item) + "&"; });
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (commentId === null)
            throw new Error("The parameter 'commentId' cannot be null.");
        else if (commentId !== undefined)
            url_ += "CommentId=" + encodeURIComponent("" + commentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCommentTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCommentTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentTagDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentTagDto[]>;
        }));
    }

    protected processAddCommentTags(response: HttpResponseBase): Observable<CommentTagDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommentTagDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteCommentTags(tagId: string | undefined, taskId: string | undefined, commentId: string | undefined): Observable<Unit> {
        let url_ = this.baseUrl + "/api/Comments/deleteTagsFromComment?";
        if (tagId === null)
            throw new Error("The parameter 'tagId' cannot be null.");
        else if (tagId !== undefined)
            url_ += "TagId=" + encodeURIComponent("" + tagId) + "&";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (commentId === null)
            throw new Error("The parameter 'commentId' cannot be null.");
        else if (commentId !== undefined)
            url_ += "CommentId=" + encodeURIComponent("" + commentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCommentTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCommentTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Unit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Unit>;
        }));
    }

    protected processDeleteCommentTags(response: HttpResponseBase): Observable<Unit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCommentTags(taskId: string | undefined, commentId: string | undefined): Observable<CommentTagDto[]> {
        let url_ = this.baseUrl + "/api/Comments/getCommentTags?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (commentId === null)
            throw new Error("The parameter 'commentId' cannot be null.");
        else if (commentId !== undefined)
            url_ += "CommentId=" + encodeURIComponent("" + commentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommentTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommentTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentTagDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentTagDto[]>;
        }));
    }

    protected processGetCommentTags(response: HttpResponseBase): Observable<CommentTagDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommentTagDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDefaultTags(): Observable<CommentTagDto[]> {
        let url_ = this.baseUrl + "/api/Comments/getDefaultTags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentTagDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentTagDto[]>;
        }));
    }

    protected processGetDefaultTags(response: HttpResponseBase): Observable<CommentTagDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommentTagDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    upsertDefaultTag(tagName: string | null | undefined): Observable<CommentTagDto> {
        let url_ = this.baseUrl + "/api/Comments/upsertDefaultTag?";
        if (tagName !== undefined && tagName !== null)
            url_ += "tagName=" + encodeURIComponent("" + tagName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertDefaultTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertDefaultTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentTagDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentTagDto>;
        }));
    }

    protected processUpsertDefaultTag(response: HttpResponseBase): Observable<CommentTagDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommentTagDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDiscussionTags(taskId: string | undefined, tagName: string | null | undefined): Observable<CommentTagDto[]> {
        let url_ = this.baseUrl + "/api/Comments/getDiscussionTags?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (tagName !== undefined && tagName !== null)
            url_ += "TagName=" + encodeURIComponent("" + tagName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiscussionTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiscussionTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentTagDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentTagDto[]>;
        }));
    }

    protected processGetDiscussionTags(response: HttpResponseBase): Observable<CommentTagDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommentTagDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    filterCommentsByTag(taskId: string | undefined, name: string | null | undefined): Observable<CommentDto[]> {
        let url_ = this.baseUrl + "/api/Comments/FilterCommentsByTag?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilterCommentsByTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilterCommentsByTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentDto[]>;
        }));
    }

    protected processFilterCommentsByTag(response: HttpResponseBase): Observable<CommentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    editComment(taskId: string | undefined, commentId: string | undefined, content: string | null | undefined, sendNotification: boolean | undefined, periodEnd: string | null | undefined, processName: string | null | undefined, clientName: string | null | undefined, networkMemberName: string | null | undefined, customSubscriberProvider: string | null | undefined, country: string | null | undefined, title: string | null | undefined, files: FileParameter[] | null | undefined): Observable<CommentDto> {
        let url_ = this.baseUrl + "/api/Comments/updateComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (taskId === null || taskId === undefined)
            throw new Error("The parameter 'taskId' cannot be null.");
        else
            content_.append("TaskId", taskId.toString());
        if (commentId === null || commentId === undefined)
            throw new Error("The parameter 'commentId' cannot be null.");
        else
            content_.append("CommentId", commentId.toString());
        if (content !== null && content !== undefined)
            content_.append("Content", content.toString());
        if (sendNotification === null || sendNotification === undefined)
            throw new Error("The parameter 'sendNotification' cannot be null.");
        else
            content_.append("SendNotification", sendNotification.toString());
        if (periodEnd !== null && periodEnd !== undefined)
            content_.append("PeriodEnd", periodEnd.toString());
        if (processName !== null && processName !== undefined)
            content_.append("ProcessName", processName.toString());
        if (clientName !== null && clientName !== undefined)
            content_.append("ClientName", clientName.toString());
        if (networkMemberName !== null && networkMemberName !== undefined)
            content_.append("NetworkMemberName", networkMemberName.toString());
        if (customSubscriberProvider !== null && customSubscriberProvider !== undefined)
            content_.append("CustomSubscriberProvider", customSubscriberProvider.toString());
        if (country !== null && country !== undefined)
            content_.append("Country", country.toString());
        if (title !== null && title !== undefined)
            content_.append("Title", title.toString());
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentDto>;
        }));
    }

    protected processEditComment(response: HttpResponseBase): Observable<CommentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addExternalComment(externalComment: AddExternalCommentsCommand): Observable<CommentDto[]> {
        let url_ = this.baseUrl + "/api/Comments/AddExternalComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(externalComment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddExternalComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddExternalComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommentDto[]>;
        }));
    }

    protected processAddExternalComment(response: HttpResponseBase): Observable<CommentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteFileFromComment(taskId: string | undefined, fileId: string | undefined): Observable<Unit> {
        let url_ = this.baseUrl + "/api/Comments/deleteFileFromComment?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFileFromComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFileFromComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Unit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Unit>;
        }));
    }

    protected processDeleteFileFromComment(response: HttpResponseBase): Observable<Unit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IContactsClient {
    getPrimaryContactFromAccount(accountId: string | null): Observable<ContactDto>;
    getConsultantContactFromAccount(accountId: string | null): Observable<ContactDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ContactsClient implements IContactsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getPrimaryContactFromAccount(accountId: string | null): Observable<ContactDto> {
        let url_ = this.baseUrl + "/api/Contacts/Account/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrimaryContactFromAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrimaryContactFromAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactDto>;
        }));
    }

    protected processGetPrimaryContactFromAccount(response: HttpResponseBase): Observable<ContactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getConsultantContactFromAccount(accountId: string | null): Observable<ContactDto> {
        let url_ = this.baseUrl + "/api/Contacts/MainConsultant/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultantContactFromAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultantContactFromAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactDto>;
        }));
    }

    protected processGetConsultantContactFromAccount(response: HttpResponseBase): Observable<ContactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICountriesClient {
    getCountries(): Observable<CountryDto[]>;
    getCounties(): Observable<CountyDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class CountriesClient implements ICountriesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getCountries(): Observable<CountryDto[]> {
        let url_ = this.baseUrl + "/api/Countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryDto[]>;
        }));
    }

    protected processGetCountries(response: HttpResponseBase): Observable<CountryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCounties(): Observable<CountyDto[]> {
        let url_ = this.baseUrl + "/api/Countries/counties";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCounties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCounties(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountyDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountyDto[]>;
        }));
    }

    protected processGetCounties(response: HttpResponseBase): Observable<CountyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICrmAttachmentsClient {
    getCrmAccountAttachments(accountId: string | null, pageNumber: number | undefined, pageSize: number | undefined): Observable<PaginatedListOfCrmAttachmentDto>;
    getCrmAccountContractualAttachments(accountId: string | null, pageNumber: number | undefined, pageSize: number | undefined): Observable<PaginatedListOfCrmAttachmentDto>;
    getCrmAccountImportantAttachments(accountId: string | null, type: string | null): Observable<CrmAttachmentDto>;
    downloadCrmAttachment(attachmentId: string | null): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class CrmAttachmentsClient implements ICrmAttachmentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getCrmAccountAttachments(accountId: string | null, pageNumber: number | undefined, pageSize: number | undefined): Observable<PaginatedListOfCrmAttachmentDto> {
        let url_ = this.baseUrl + "/api/CrmAttachments/filter/{accountId}?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCrmAccountAttachments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCrmAccountAttachments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedListOfCrmAttachmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedListOfCrmAttachmentDto>;
        }));
    }

    protected processGetCrmAccountAttachments(response: HttpResponseBase): Observable<PaginatedListOfCrmAttachmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfCrmAttachmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCrmAccountContractualAttachments(accountId: string | null, pageNumber: number | undefined, pageSize: number | undefined): Observable<PaginatedListOfCrmAttachmentDto> {
        let url_ = this.baseUrl + "/api/CrmAttachments/filter/{accountId}/contractual?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCrmAccountContractualAttachments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCrmAccountContractualAttachments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedListOfCrmAttachmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedListOfCrmAttachmentDto>;
        }));
    }

    protected processGetCrmAccountContractualAttachments(response: HttpResponseBase): Observable<PaginatedListOfCrmAttachmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfCrmAttachmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCrmAccountImportantAttachments(accountId: string | null, type: string | null): Observable<CrmAttachmentDto> {
        let url_ = this.baseUrl + "/api/CrmAttachments/filter/{accountId}/important/{type}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCrmAccountImportantAttachments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCrmAccountImportantAttachments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CrmAttachmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CrmAttachmentDto>;
        }));
    }

    protected processGetCrmAccountImportantAttachments(response: HttpResponseBase): Observable<CrmAttachmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CrmAttachmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadCrmAttachment(attachmentId: string | null): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/CrmAttachments/download/{attachmentId}";
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadCrmAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadCrmAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadCrmAttachment(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDocumentsClient {
    downloadFile(path: string | null | undefined, networkMemberIds: string[] | null | undefined): Observable<FileResponse>;
    getIllustrationFile(path: string | null | undefined): Observable<string>;
    getAdminDbDocumentInPdf(path: string | null | undefined): Observable<string>;
    getDocumentByPath(path: string | null | undefined): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class DocumentsClient implements IDocumentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    downloadFile(path: string | null | undefined, networkMemberIds: string[] | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Documents/AdminDb?";
        if (path !== undefined && path !== null)
            url_ += "Path=" + encodeURIComponent("" + path) + "&";
        if (networkMemberIds !== undefined && networkMemberIds !== null)
            networkMemberIds && networkMemberIds.forEach(item => { url_ += "NetworkMemberIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getIllustrationFile(path: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Documents/getIllustrationFile?";
        if (path !== undefined && path !== null)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIllustrationFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIllustrationFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetIllustrationFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAdminDbDocumentInPdf(path: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Documents/getAdminDbDocumentInPdf?";
        if (path !== undefined && path !== null)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminDbDocumentInPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminDbDocumentInPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAdminDbDocumentInPdf(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocumentByPath(path: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Documents/getDocumentByPath?";
        if (path !== undefined && path !== null)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentByPath(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentByPath(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetDocumentByPath(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDocuSignClient {
    getDocumentToSignUrl(signerName: string | null | undefined, signerEmail: string | null | undefined, signerClientId: string | null | undefined, returnUrl: string | null | undefined, docPdfFile: FileParameter | null | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class DocuSignClient implements IDocuSignClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getDocumentToSignUrl(signerName: string | null | undefined, signerEmail: string | null | undefined, signerClientId: string | null | undefined, returnUrl: string | null | undefined, docPdfFile: FileParameter | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/DocuSign?";
        if (signerName !== undefined && signerName !== null)
            url_ += "signerName=" + encodeURIComponent("" + signerName) + "&";
        if (signerEmail !== undefined && signerEmail !== null)
            url_ += "signerEmail=" + encodeURIComponent("" + signerEmail) + "&";
        if (signerClientId !== undefined && signerClientId !== null)
            url_ += "signerClientId=" + encodeURIComponent("" + signerClientId) + "&";
        if (returnUrl !== undefined && returnUrl !== null)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (docPdfFile !== null && docPdfFile !== undefined)
            content_.append("docPdfFile", docPdfFile.data, docPdfFile.fileName ? docPdfFile.fileName : "docPdfFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentToSignUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentToSignUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDocumentToSignUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IFaqCategoriesClient {
    getFaqCategories(): Observable<FaqCategoryDto[]>;
    addFaqCategory(name: string | null | undefined, sortOrder: number | undefined): Observable<string>;
    deleteFaqCategory(id: string | undefined): Observable<Unit>;
    addFaqQuestion(categoryId: string | undefined, title: string | null | undefined, answer: string | null | undefined): Observable<string>;
    updateFaqCategory(command: UpdateFaqCommand): Observable<Unit>;
}

@Injectable({
    providedIn: 'root'
})
export class FaqCategoriesClient implements IFaqCategoriesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getFaqCategories(): Observable<FaqCategoryDto[]> {
        let url_ = this.baseUrl + "/api/FaqCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFaqCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFaqCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FaqCategoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FaqCategoryDto[]>;
        }));
    }

    protected processGetFaqCategories(response: HttpResponseBase): Observable<FaqCategoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FaqCategoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addFaqCategory(name: string | null | undefined, sortOrder: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/FaqCategories?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (sortOrder === null)
            throw new Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFaqCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFaqCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddFaqCategory(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteFaqCategory(id: string | undefined): Observable<Unit> {
        let url_ = this.baseUrl + "/api/FaqCategories?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFaqCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFaqCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Unit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Unit>;
        }));
    }

    protected processDeleteFaqCategory(response: HttpResponseBase): Observable<Unit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addFaqQuestion(categoryId: string | undefined, title: string | null | undefined, answer: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/FaqCategories/question?";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (title !== undefined && title !== null)
            url_ += "Title=" + encodeURIComponent("" + title) + "&";
        if (answer !== undefined && answer !== null)
            url_ += "Answer=" + encodeURIComponent("" + answer) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFaqQuestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFaqQuestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddFaqQuestion(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateFaqCategory(command: UpdateFaqCommand): Observable<Unit> {
        let url_ = this.baseUrl + "/api/FaqCategories/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFaqCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFaqCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Unit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Unit>;
        }));
    }

    protected processUpdateFaqCategory(response: HttpResponseBase): Observable<Unit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IFileUploadTasksClient {
    getById(id: string): Observable<FileUploadTaskDto>;
    getBySourceId(sourceId: string | null, processId: string | null | undefined): Observable<FileUploadTaskDto>;
    getMyOrganization(filterParameter_Id: string | undefined, filterParameter_SourceId: string | null | undefined, filterParameter_Title: string | null | undefined, filterParameter_SubTitle: string | null | undefined, filterParameter_DisplayDate: Date | undefined, filterParameter_ProcessId: string | null | undefined, filterParameter_NetworkMemberId: string | null | undefined, filterParameter_ClientId: string | null | undefined, filterParameter_Country: string | null | undefined, filterParameter_Status: TasksStatus | null | undefined, filterParameter_ClientName: string | null | undefined, filterParameter_NetworkMemberIds: string[] | null | undefined, filterParameter_SubscriberId: string | null | undefined, filterParameter_SearchDateLimit: Date | null | undefined, filterParameter_OverdueDate: number | null | undefined, filterParameter_ModifiedDate: Date | null | undefined, filterParameter_PayTo: PayToEnum | null | undefined, sortingElements: SortingElement[] | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<FileUploadTaskDto[]>;
    getTasks(filterParameter_Id: string | undefined, filterParameter_SourceId: string | null | undefined, filterParameter_Title: string | null | undefined, filterParameter_SubTitle: string | null | undefined, filterParameter_DisplayDate: Date | undefined, filterParameter_ProcessId: string | null | undefined, filterParameter_NetworkMemberId: string | null | undefined, filterParameter_ClientId: string | null | undefined, filterParameter_Country: string | null | undefined, filterParameter_Status: TasksStatus | null | undefined, filterParameter_ClientName: string | null | undefined, filterParameter_NetworkMemberIds: string[] | null | undefined, filterParameter_SubscriberId: string | null | undefined, filterParameter_SearchDateLimit: Date | null | undefined, filterParameter_OverdueDate: number | null | undefined, filterParameter_ModifiedDate: Date | null | undefined, filterParameter_PayTo: PayToEnum | null | undefined, sortingElements: SortingElement[] | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<FileUploadTaskDto[]>;
    uploadFile(taskId: string, processId: string | null | undefined, submit: boolean | undefined, file: FileParameter | null | undefined): Observable<string>;
    downloadFile(taskId: string | undefined, fileId: string | undefined, systemAttachment: boolean | undefined): Observable<string>;
    downloadFileFromPath(taskId: string | undefined, attachmentPath: string | null | undefined): Observable<string>;
    upsert(command: UpsertFileUploadTaskCommand): Observable<string>;
    batchUpsert(command: UpsertFileUploadTaskCommand[]): Observable<number>;
    getTaskSubscribersByTaskId(taskId: string): Observable<TaskSubscribersDto>;
    changeTaskStatus(id: string | undefined, status: TasksStatus | undefined): Observable<Unit>;
    copyRemainingAccountInputDoublons(accountYear: string | null | undefined): Observable<Unit>;
    changeActionPerform(id: string | undefined, actionPerform: ActionPerform | undefined): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class FileUploadTasksClient implements IFileUploadTasksClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getById(id: string): Observable<FileUploadTaskDto> {
        let url_ = this.baseUrl + "/api/FileUploadTasks/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadTaskDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadTaskDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<FileUploadTaskDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadTaskDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBySourceId(sourceId: string | null, processId: string | null | undefined): Observable<FileUploadTaskDto> {
        let url_ = this.baseUrl + "/api/FileUploadTasks/sourceId/{sourceId}?";
        if (sourceId === undefined || sourceId === null)
            throw new Error("The parameter 'sourceId' must be defined.");
        url_ = url_.replace("{sourceId}", encodeURIComponent("" + sourceId));
        if (processId !== undefined && processId !== null)
            url_ += "processId=" + encodeURIComponent("" + processId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBySourceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBySourceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadTaskDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadTaskDto>;
        }));
    }

    protected processGetBySourceId(response: HttpResponseBase): Observable<FileUploadTaskDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileUploadTaskDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyOrganization(filterParameter_Id: string | undefined, filterParameter_SourceId: string | null | undefined, filterParameter_Title: string | null | undefined, filterParameter_SubTitle: string | null | undefined, filterParameter_DisplayDate: Date | undefined, filterParameter_ProcessId: string | null | undefined, filterParameter_NetworkMemberId: string | null | undefined, filterParameter_ClientId: string | null | undefined, filterParameter_Country: string | null | undefined, filterParameter_Status: TasksStatus | null | undefined, filterParameter_ClientName: string | null | undefined, filterParameter_NetworkMemberIds: string[] | null | undefined, filterParameter_SubscriberId: string | null | undefined, filterParameter_SearchDateLimit: Date | null | undefined, filterParameter_OverdueDate: number | null | undefined, filterParameter_ModifiedDate: Date | null | undefined, filterParameter_PayTo: PayToEnum | null | undefined, sortingElements: SortingElement[] | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<FileUploadTaskDto[]> {
        let url_ = this.baseUrl + "/api/FileUploadTasks/myOrganization?";
        if (filterParameter_Id === null)
            throw new Error("The parameter 'filterParameter_Id' cannot be null.");
        else if (filterParameter_Id !== undefined)
            url_ += "FilterParameter.Id=" + encodeURIComponent("" + filterParameter_Id) + "&";
        if (filterParameter_SourceId !== undefined && filterParameter_SourceId !== null)
            url_ += "FilterParameter.SourceId=" + encodeURIComponent("" + filterParameter_SourceId) + "&";
        if (filterParameter_Title !== undefined && filterParameter_Title !== null)
            url_ += "FilterParameter.Title=" + encodeURIComponent("" + filterParameter_Title) + "&";
        if (filterParameter_SubTitle !== undefined && filterParameter_SubTitle !== null)
            url_ += "FilterParameter.SubTitle=" + encodeURIComponent("" + filterParameter_SubTitle) + "&";
        if (filterParameter_DisplayDate === null)
            throw new Error("The parameter 'filterParameter_DisplayDate' cannot be null.");
        else if (filterParameter_DisplayDate !== undefined)
            url_ += "FilterParameter.DisplayDate=" + encodeURIComponent(filterParameter_DisplayDate ? "" + filterParameter_DisplayDate.toISOString() : "") + "&";
        if (filterParameter_ProcessId !== undefined && filterParameter_ProcessId !== null)
            url_ += "FilterParameter.ProcessId=" + encodeURIComponent("" + filterParameter_ProcessId) + "&";
        if (filterParameter_NetworkMemberId !== undefined && filterParameter_NetworkMemberId !== null)
            url_ += "FilterParameter.NetworkMemberId=" + encodeURIComponent("" + filterParameter_NetworkMemberId) + "&";
        if (filterParameter_ClientId !== undefined && filterParameter_ClientId !== null)
            url_ += "FilterParameter.ClientId=" + encodeURIComponent("" + filterParameter_ClientId) + "&";
        if (filterParameter_Country !== undefined && filterParameter_Country !== null)
            url_ += "FilterParameter.Country=" + encodeURIComponent("" + filterParameter_Country) + "&";
        if (filterParameter_Status !== undefined && filterParameter_Status !== null)
            url_ += "FilterParameter.Status=" + encodeURIComponent("" + filterParameter_Status) + "&";
        if (filterParameter_ClientName !== undefined && filterParameter_ClientName !== null)
            url_ += "FilterParameter.ClientName=" + encodeURIComponent("" + filterParameter_ClientName) + "&";
        if (filterParameter_NetworkMemberIds !== undefined && filterParameter_NetworkMemberIds !== null)
            filterParameter_NetworkMemberIds && filterParameter_NetworkMemberIds.forEach(item => { url_ += "FilterParameter.NetworkMemberIds=" + encodeURIComponent("" + item) + "&"; });
        if (filterParameter_SubscriberId !== undefined && filterParameter_SubscriberId !== null)
            url_ += "FilterParameter.SubscriberId=" + encodeURIComponent("" + filterParameter_SubscriberId) + "&";
        if (filterParameter_SearchDateLimit !== undefined && filterParameter_SearchDateLimit !== null)
            url_ += "FilterParameter.SearchDateLimit=" + encodeURIComponent(filterParameter_SearchDateLimit ? "" + filterParameter_SearchDateLimit.toISOString() : "") + "&";
        if (filterParameter_OverdueDate !== undefined && filterParameter_OverdueDate !== null)
            url_ += "FilterParameter.OverdueDate=" + encodeURIComponent("" + filterParameter_OverdueDate) + "&";
        if (filterParameter_ModifiedDate !== undefined && filterParameter_ModifiedDate !== null)
            url_ += "FilterParameter.ModifiedDate=" + encodeURIComponent(filterParameter_ModifiedDate ? "" + filterParameter_ModifiedDate.toISOString() : "") + "&";
        if (filterParameter_PayTo !== undefined && filterParameter_PayTo !== null)
            url_ += "FilterParameter.PayTo=" + encodeURIComponent("" + filterParameter_PayTo) + "&";
        if (sortingElements !== undefined && sortingElements !== null)
            sortingElements && sortingElements.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortingElements[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadTaskDto[]>;
        }));
    }

    protected processGetMyOrganization(response: HttpResponseBase): Observable<FileUploadTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileUploadTaskDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTasks(filterParameter_Id: string | undefined, filterParameter_SourceId: string | null | undefined, filterParameter_Title: string | null | undefined, filterParameter_SubTitle: string | null | undefined, filterParameter_DisplayDate: Date | undefined, filterParameter_ProcessId: string | null | undefined, filterParameter_NetworkMemberId: string | null | undefined, filterParameter_ClientId: string | null | undefined, filterParameter_Country: string | null | undefined, filterParameter_Status: TasksStatus | null | undefined, filterParameter_ClientName: string | null | undefined, filterParameter_NetworkMemberIds: string[] | null | undefined, filterParameter_SubscriberId: string | null | undefined, filterParameter_SearchDateLimit: Date | null | undefined, filterParameter_OverdueDate: number | null | undefined, filterParameter_ModifiedDate: Date | null | undefined, filterParameter_PayTo: PayToEnum | null | undefined, sortingElements: SortingElement[] | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<FileUploadTaskDto[]> {
        let url_ = this.baseUrl + "/api/FileUploadTasks/filter?";
        if (filterParameter_Id === null)
            throw new Error("The parameter 'filterParameter_Id' cannot be null.");
        else if (filterParameter_Id !== undefined)
            url_ += "FilterParameter.Id=" + encodeURIComponent("" + filterParameter_Id) + "&";
        if (filterParameter_SourceId !== undefined && filterParameter_SourceId !== null)
            url_ += "FilterParameter.SourceId=" + encodeURIComponent("" + filterParameter_SourceId) + "&";
        if (filterParameter_Title !== undefined && filterParameter_Title !== null)
            url_ += "FilterParameter.Title=" + encodeURIComponent("" + filterParameter_Title) + "&";
        if (filterParameter_SubTitle !== undefined && filterParameter_SubTitle !== null)
            url_ += "FilterParameter.SubTitle=" + encodeURIComponent("" + filterParameter_SubTitle) + "&";
        if (filterParameter_DisplayDate === null)
            throw new Error("The parameter 'filterParameter_DisplayDate' cannot be null.");
        else if (filterParameter_DisplayDate !== undefined)
            url_ += "FilterParameter.DisplayDate=" + encodeURIComponent(filterParameter_DisplayDate ? "" + filterParameter_DisplayDate.toISOString() : "") + "&";
        if (filterParameter_ProcessId !== undefined && filterParameter_ProcessId !== null)
            url_ += "FilterParameter.ProcessId=" + encodeURIComponent("" + filterParameter_ProcessId) + "&";
        if (filterParameter_NetworkMemberId !== undefined && filterParameter_NetworkMemberId !== null)
            url_ += "FilterParameter.NetworkMemberId=" + encodeURIComponent("" + filterParameter_NetworkMemberId) + "&";
        if (filterParameter_ClientId !== undefined && filterParameter_ClientId !== null)
            url_ += "FilterParameter.ClientId=" + encodeURIComponent("" + filterParameter_ClientId) + "&";
        if (filterParameter_Country !== undefined && filterParameter_Country !== null)
            url_ += "FilterParameter.Country=" + encodeURIComponent("" + filterParameter_Country) + "&";
        if (filterParameter_Status !== undefined && filterParameter_Status !== null)
            url_ += "FilterParameter.Status=" + encodeURIComponent("" + filterParameter_Status) + "&";
        if (filterParameter_ClientName !== undefined && filterParameter_ClientName !== null)
            url_ += "FilterParameter.ClientName=" + encodeURIComponent("" + filterParameter_ClientName) + "&";
        if (filterParameter_NetworkMemberIds !== undefined && filterParameter_NetworkMemberIds !== null)
            filterParameter_NetworkMemberIds && filterParameter_NetworkMemberIds.forEach(item => { url_ += "FilterParameter.NetworkMemberIds=" + encodeURIComponent("" + item) + "&"; });
        if (filterParameter_SubscriberId !== undefined && filterParameter_SubscriberId !== null)
            url_ += "FilterParameter.SubscriberId=" + encodeURIComponent("" + filterParameter_SubscriberId) + "&";
        if (filterParameter_SearchDateLimit !== undefined && filterParameter_SearchDateLimit !== null)
            url_ += "FilterParameter.SearchDateLimit=" + encodeURIComponent(filterParameter_SearchDateLimit ? "" + filterParameter_SearchDateLimit.toISOString() : "") + "&";
        if (filterParameter_OverdueDate !== undefined && filterParameter_OverdueDate !== null)
            url_ += "FilterParameter.OverdueDate=" + encodeURIComponent("" + filterParameter_OverdueDate) + "&";
        if (filterParameter_ModifiedDate !== undefined && filterParameter_ModifiedDate !== null)
            url_ += "FilterParameter.ModifiedDate=" + encodeURIComponent(filterParameter_ModifiedDate ? "" + filterParameter_ModifiedDate.toISOString() : "") + "&";
        if (filterParameter_PayTo !== undefined && filterParameter_PayTo !== null)
            url_ += "FilterParameter.PayTo=" + encodeURIComponent("" + filterParameter_PayTo) + "&";
        if (sortingElements !== undefined && sortingElements !== null)
            sortingElements && sortingElements.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortingElements[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileUploadTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileUploadTaskDto[]>;
        }));
    }

    protected processGetTasks(response: HttpResponseBase): Observable<FileUploadTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileUploadTaskDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadFile(taskId: string, processId: string | null | undefined, submit: boolean | undefined, file: FileParameter | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/FileUploadTasks/{taskId}?";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (processId !== undefined && processId !== null)
            url_ += "processId=" + encodeURIComponent("" + processId) + "&";
        if (submit === null)
            throw new Error("The parameter 'submit' cannot be null.");
        else if (submit !== undefined)
            url_ += "submit=" + encodeURIComponent("" + submit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadFile(taskId: string | undefined, fileId: string | undefined, systemAttachment: boolean | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/FileUploadTasks/Download?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";
        if (systemAttachment === null)
            throw new Error("The parameter 'systemAttachment' cannot be null.");
        else if (systemAttachment !== undefined)
            url_ += "SystemAttachment=" + encodeURIComponent("" + systemAttachment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadFileFromPath(taskId: string | undefined, attachmentPath: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/FileUploadTasks/DownloadFromPath?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (attachmentPath !== undefined && attachmentPath !== null)
            url_ += "AttachmentPath=" + encodeURIComponent("" + attachmentPath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFileFromPath(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFileFromPath(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDownloadFileFromPath(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    upsert(command: UpsertFileUploadTaskCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/FileUploadTasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    batchUpsert(command: UpsertFileUploadTaskCommand[]): Observable<number> {
        let url_ = this.baseUrl + "/api/FileUploadTasks/batchUpsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatchUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchUpsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processBatchUpsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTaskSubscribersByTaskId(taskId: string): Observable<TaskSubscribersDto> {
        let url_ = this.baseUrl + "/api/FileUploadTasks/{taskId}/tasksubscribers";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskSubscribersByTaskId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskSubscribersByTaskId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskSubscribersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskSubscribersDto>;
        }));
    }

    protected processGetTaskSubscribersByTaskId(response: HttpResponseBase): Observable<TaskSubscribersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskSubscribersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeTaskStatus(id: string | undefined, status: TasksStatus | undefined): Observable<Unit> {
        let url_ = this.baseUrl + "/api/FileUploadTasks/updateTaskStatus?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeTaskStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeTaskStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Unit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Unit>;
        }));
    }

    protected processChangeTaskStatus(response: HttpResponseBase): Observable<Unit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    copyRemainingAccountInputDoublons(accountYear: string | null | undefined): Observable<Unit> {
        let url_ = this.baseUrl + "/api/FileUploadTasks/CopyRemainingAccountInputDoublons?";
        if (accountYear !== undefined && accountYear !== null)
            url_ += "accountYear=" + encodeURIComponent("" + accountYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyRemainingAccountInputDoublons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyRemainingAccountInputDoublons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Unit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Unit>;
        }));
    }

    protected processCopyRemainingAccountInputDoublons(response: HttpResponseBase): Observable<Unit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeActionPerform(id: string | undefined, actionPerform: ActionPerform | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/FileUploadTasks/changeActionPerform?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (actionPerform === null)
            throw new Error("The parameter 'actionPerform' cannot be null.");
        else if (actionPerform !== undefined)
            url_ += "ActionPerform=" + encodeURIComponent("" + actionPerform) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeActionPerform(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeActionPerform(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangeActionPerform(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IGeneralTaskClient {
    getMyOrganization(filterParameter_Id: string | undefined, filterParameter_SourceId: string | null | undefined, filterParameter_Title: string | null | undefined, filterParameter_SubTitle: string | null | undefined, filterParameter_DisplayDate: Date | undefined, filterParameter_ProcessId: string | null | undefined, filterParameter_NetworkMemberId: string | null | undefined, filterParameter_ClientId: string | null | undefined, filterParameter_Country: string | null | undefined, filterParameter_Status: TasksStatus | null | undefined, filterParameter_ClientName: string | null | undefined, filterParameter_NetworkMemberIds: string[] | null | undefined, filterParameter_SubscriberId: string | null | undefined, filterParameter_SearchDateLimit: Date | null | undefined, filterParameter_OverdueDate: number | null | undefined, filterParameter_ModifiedDate: Date | null | undefined, filterParameter_PayTo: PayToEnum | null | undefined, sortingElements: SortingElement[] | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<GeneralTaskDto[]>;
    getTasksById(taskId: string): Observable<GeneralTaskDto>;
    getTasks(filterParameter_Id: string | undefined, filterParameter_SourceId: string | null | undefined, filterParameter_Title: string | null | undefined, filterParameter_SubTitle: string | null | undefined, filterParameter_DisplayDate: Date | undefined, filterParameter_ProcessId: string | null | undefined, filterParameter_NetworkMemberId: string | null | undefined, filterParameter_ClientId: string | null | undefined, filterParameter_Country: string | null | undefined, filterParameter_Status: TasksStatus | null | undefined, filterParameter_ClientName: string | null | undefined, filterParameter_NetworkMemberIds: string[] | null | undefined, filterParameter_SubscriberId: string | null | undefined, filterParameter_SearchDateLimit: Date | null | undefined, filterParameter_OverdueDate: number | null | undefined, filterParameter_ModifiedDate: Date | null | undefined, filterParameter_PayTo: PayToEnum | null | undefined, sortingElements: SortingElement[] | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<GeneralTaskDto[]>;
    downloadFile(taskId: string | undefined, fileId: string | undefined, systemAttachment: boolean | undefined): Observable<string>;
    downloadFileFromPath(taskId: string | undefined, attachmentPath: string | null | undefined): Observable<string>;
    upsert(command: UpsertGeneralTaskCommand): Observable<string>;
    batchUpsert(tasks: UpsertGeneralTaskCommand[]): Observable<string[]>;
    getTaskSubscribersByTaskId(taskId: string): Observable<TaskSubscribersDto>;
    changeTaskStatus(id: string | undefined, status: TasksStatus | undefined): Observable<Unit>;
    changeActionPerform(id: string | undefined, actionPerform: ActionPerform | undefined): Observable<boolean>;
    mergeTasks(originTaskId: string | undefined, destinationTaskId: string | undefined): Observable<GeneralTaskDto>;
}

@Injectable({
    providedIn: 'root'
})
export class GeneralTaskClient implements IGeneralTaskClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getMyOrganization(filterParameter_Id: string | undefined, filterParameter_SourceId: string | null | undefined, filterParameter_Title: string | null | undefined, filterParameter_SubTitle: string | null | undefined, filterParameter_DisplayDate: Date | undefined, filterParameter_ProcessId: string | null | undefined, filterParameter_NetworkMemberId: string | null | undefined, filterParameter_ClientId: string | null | undefined, filterParameter_Country: string | null | undefined, filterParameter_Status: TasksStatus | null | undefined, filterParameter_ClientName: string | null | undefined, filterParameter_NetworkMemberIds: string[] | null | undefined, filterParameter_SubscriberId: string | null | undefined, filterParameter_SearchDateLimit: Date | null | undefined, filterParameter_OverdueDate: number | null | undefined, filterParameter_ModifiedDate: Date | null | undefined, filterParameter_PayTo: PayToEnum | null | undefined, sortingElements: SortingElement[] | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<GeneralTaskDto[]> {
        let url_ = this.baseUrl + "/api/GeneralTask/myOrganization?";
        if (filterParameter_Id === null)
            throw new Error("The parameter 'filterParameter_Id' cannot be null.");
        else if (filterParameter_Id !== undefined)
            url_ += "FilterParameter.Id=" + encodeURIComponent("" + filterParameter_Id) + "&";
        if (filterParameter_SourceId !== undefined && filterParameter_SourceId !== null)
            url_ += "FilterParameter.SourceId=" + encodeURIComponent("" + filterParameter_SourceId) + "&";
        if (filterParameter_Title !== undefined && filterParameter_Title !== null)
            url_ += "FilterParameter.Title=" + encodeURIComponent("" + filterParameter_Title) + "&";
        if (filterParameter_SubTitle !== undefined && filterParameter_SubTitle !== null)
            url_ += "FilterParameter.SubTitle=" + encodeURIComponent("" + filterParameter_SubTitle) + "&";
        if (filterParameter_DisplayDate === null)
            throw new Error("The parameter 'filterParameter_DisplayDate' cannot be null.");
        else if (filterParameter_DisplayDate !== undefined)
            url_ += "FilterParameter.DisplayDate=" + encodeURIComponent(filterParameter_DisplayDate ? "" + filterParameter_DisplayDate.toISOString() : "") + "&";
        if (filterParameter_ProcessId !== undefined && filterParameter_ProcessId !== null)
            url_ += "FilterParameter.ProcessId=" + encodeURIComponent("" + filterParameter_ProcessId) + "&";
        if (filterParameter_NetworkMemberId !== undefined && filterParameter_NetworkMemberId !== null)
            url_ += "FilterParameter.NetworkMemberId=" + encodeURIComponent("" + filterParameter_NetworkMemberId) + "&";
        if (filterParameter_ClientId !== undefined && filterParameter_ClientId !== null)
            url_ += "FilterParameter.ClientId=" + encodeURIComponent("" + filterParameter_ClientId) + "&";
        if (filterParameter_Country !== undefined && filterParameter_Country !== null)
            url_ += "FilterParameter.Country=" + encodeURIComponent("" + filterParameter_Country) + "&";
        if (filterParameter_Status !== undefined && filterParameter_Status !== null)
            url_ += "FilterParameter.Status=" + encodeURIComponent("" + filterParameter_Status) + "&";
        if (filterParameter_ClientName !== undefined && filterParameter_ClientName !== null)
            url_ += "FilterParameter.ClientName=" + encodeURIComponent("" + filterParameter_ClientName) + "&";
        if (filterParameter_NetworkMemberIds !== undefined && filterParameter_NetworkMemberIds !== null)
            filterParameter_NetworkMemberIds && filterParameter_NetworkMemberIds.forEach(item => { url_ += "FilterParameter.NetworkMemberIds=" + encodeURIComponent("" + item) + "&"; });
        if (filterParameter_SubscriberId !== undefined && filterParameter_SubscriberId !== null)
            url_ += "FilterParameter.SubscriberId=" + encodeURIComponent("" + filterParameter_SubscriberId) + "&";
        if (filterParameter_SearchDateLimit !== undefined && filterParameter_SearchDateLimit !== null)
            url_ += "FilterParameter.SearchDateLimit=" + encodeURIComponent(filterParameter_SearchDateLimit ? "" + filterParameter_SearchDateLimit.toISOString() : "") + "&";
        if (filterParameter_OverdueDate !== undefined && filterParameter_OverdueDate !== null)
            url_ += "FilterParameter.OverdueDate=" + encodeURIComponent("" + filterParameter_OverdueDate) + "&";
        if (filterParameter_ModifiedDate !== undefined && filterParameter_ModifiedDate !== null)
            url_ += "FilterParameter.ModifiedDate=" + encodeURIComponent(filterParameter_ModifiedDate ? "" + filterParameter_ModifiedDate.toISOString() : "") + "&";
        if (filterParameter_PayTo !== undefined && filterParameter_PayTo !== null)
            url_ += "FilterParameter.PayTo=" + encodeURIComponent("" + filterParameter_PayTo) + "&";
        if (sortingElements !== undefined && sortingElements !== null)
            sortingElements && sortingElements.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortingElements[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralTaskDto[]>;
        }));
    }

    protected processGetMyOrganization(response: HttpResponseBase): Observable<GeneralTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralTaskDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTasksById(taskId: string): Observable<GeneralTaskDto> {
        let url_ = this.baseUrl + "/api/GeneralTask/{taskId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTasksById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTasksById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralTaskDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralTaskDto>;
        }));
    }

    protected processGetTasksById(response: HttpResponseBase): Observable<GeneralTaskDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralTaskDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTasks(filterParameter_Id: string | undefined, filterParameter_SourceId: string | null | undefined, filterParameter_Title: string | null | undefined, filterParameter_SubTitle: string | null | undefined, filterParameter_DisplayDate: Date | undefined, filterParameter_ProcessId: string | null | undefined, filterParameter_NetworkMemberId: string | null | undefined, filterParameter_ClientId: string | null | undefined, filterParameter_Country: string | null | undefined, filterParameter_Status: TasksStatus | null | undefined, filterParameter_ClientName: string | null | undefined, filterParameter_NetworkMemberIds: string[] | null | undefined, filterParameter_SubscriberId: string | null | undefined, filterParameter_SearchDateLimit: Date | null | undefined, filterParameter_OverdueDate: number | null | undefined, filterParameter_ModifiedDate: Date | null | undefined, filterParameter_PayTo: PayToEnum | null | undefined, sortingElements: SortingElement[] | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<GeneralTaskDto[]> {
        let url_ = this.baseUrl + "/api/GeneralTask/filter?";
        if (filterParameter_Id === null)
            throw new Error("The parameter 'filterParameter_Id' cannot be null.");
        else if (filterParameter_Id !== undefined)
            url_ += "FilterParameter.Id=" + encodeURIComponent("" + filterParameter_Id) + "&";
        if (filterParameter_SourceId !== undefined && filterParameter_SourceId !== null)
            url_ += "FilterParameter.SourceId=" + encodeURIComponent("" + filterParameter_SourceId) + "&";
        if (filterParameter_Title !== undefined && filterParameter_Title !== null)
            url_ += "FilterParameter.Title=" + encodeURIComponent("" + filterParameter_Title) + "&";
        if (filterParameter_SubTitle !== undefined && filterParameter_SubTitle !== null)
            url_ += "FilterParameter.SubTitle=" + encodeURIComponent("" + filterParameter_SubTitle) + "&";
        if (filterParameter_DisplayDate === null)
            throw new Error("The parameter 'filterParameter_DisplayDate' cannot be null.");
        else if (filterParameter_DisplayDate !== undefined)
            url_ += "FilterParameter.DisplayDate=" + encodeURIComponent(filterParameter_DisplayDate ? "" + filterParameter_DisplayDate.toISOString() : "") + "&";
        if (filterParameter_ProcessId !== undefined && filterParameter_ProcessId !== null)
            url_ += "FilterParameter.ProcessId=" + encodeURIComponent("" + filterParameter_ProcessId) + "&";
        if (filterParameter_NetworkMemberId !== undefined && filterParameter_NetworkMemberId !== null)
            url_ += "FilterParameter.NetworkMemberId=" + encodeURIComponent("" + filterParameter_NetworkMemberId) + "&";
        if (filterParameter_ClientId !== undefined && filterParameter_ClientId !== null)
            url_ += "FilterParameter.ClientId=" + encodeURIComponent("" + filterParameter_ClientId) + "&";
        if (filterParameter_Country !== undefined && filterParameter_Country !== null)
            url_ += "FilterParameter.Country=" + encodeURIComponent("" + filterParameter_Country) + "&";
        if (filterParameter_Status !== undefined && filterParameter_Status !== null)
            url_ += "FilterParameter.Status=" + encodeURIComponent("" + filterParameter_Status) + "&";
        if (filterParameter_ClientName !== undefined && filterParameter_ClientName !== null)
            url_ += "FilterParameter.ClientName=" + encodeURIComponent("" + filterParameter_ClientName) + "&";
        if (filterParameter_NetworkMemberIds !== undefined && filterParameter_NetworkMemberIds !== null)
            filterParameter_NetworkMemberIds && filterParameter_NetworkMemberIds.forEach(item => { url_ += "FilterParameter.NetworkMemberIds=" + encodeURIComponent("" + item) + "&"; });
        if (filterParameter_SubscriberId !== undefined && filterParameter_SubscriberId !== null)
            url_ += "FilterParameter.SubscriberId=" + encodeURIComponent("" + filterParameter_SubscriberId) + "&";
        if (filterParameter_SearchDateLimit !== undefined && filterParameter_SearchDateLimit !== null)
            url_ += "FilterParameter.SearchDateLimit=" + encodeURIComponent(filterParameter_SearchDateLimit ? "" + filterParameter_SearchDateLimit.toISOString() : "") + "&";
        if (filterParameter_OverdueDate !== undefined && filterParameter_OverdueDate !== null)
            url_ += "FilterParameter.OverdueDate=" + encodeURIComponent("" + filterParameter_OverdueDate) + "&";
        if (filterParameter_ModifiedDate !== undefined && filterParameter_ModifiedDate !== null)
            url_ += "FilterParameter.ModifiedDate=" + encodeURIComponent(filterParameter_ModifiedDate ? "" + filterParameter_ModifiedDate.toISOString() : "") + "&";
        if (filterParameter_PayTo !== undefined && filterParameter_PayTo !== null)
            url_ += "FilterParameter.PayTo=" + encodeURIComponent("" + filterParameter_PayTo) + "&";
        if (sortingElements !== undefined && sortingElements !== null)
            sortingElements && sortingElements.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortingElements[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralTaskDto[]>;
        }));
    }

    protected processGetTasks(response: HttpResponseBase): Observable<GeneralTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralTaskDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadFile(taskId: string | undefined, fileId: string | undefined, systemAttachment: boolean | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/GeneralTask/Download?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";
        if (systemAttachment === null)
            throw new Error("The parameter 'systemAttachment' cannot be null.");
        else if (systemAttachment !== undefined)
            url_ += "SystemAttachment=" + encodeURIComponent("" + systemAttachment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadFileFromPath(taskId: string | undefined, attachmentPath: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/GeneralTask/downloadFromPath?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (attachmentPath !== undefined && attachmentPath !== null)
            url_ += "AttachmentPath=" + encodeURIComponent("" + attachmentPath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFileFromPath(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFileFromPath(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDownloadFileFromPath(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    upsert(command: UpsertGeneralTaskCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/GeneralTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    batchUpsert(tasks: UpsertGeneralTaskCommand[]): Observable<string[]> {
        let url_ = this.baseUrl + "/api/GeneralTask/batchupsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tasks);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatchUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchUpsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processBatchUpsert(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTaskSubscribersByTaskId(taskId: string): Observable<TaskSubscribersDto> {
        let url_ = this.baseUrl + "/api/GeneralTask/{taskId}/tasksubscribers";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskSubscribersByTaskId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskSubscribersByTaskId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskSubscribersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskSubscribersDto>;
        }));
    }

    protected processGetTaskSubscribersByTaskId(response: HttpResponseBase): Observable<TaskSubscribersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskSubscribersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeTaskStatus(id: string | undefined, status: TasksStatus | undefined): Observable<Unit> {
        let url_ = this.baseUrl + "/api/GeneralTask/updateTaskStatus?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeTaskStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeTaskStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Unit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Unit>;
        }));
    }

    protected processChangeTaskStatus(response: HttpResponseBase): Observable<Unit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeActionPerform(id: string | undefined, actionPerform: ActionPerform | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/GeneralTask/changeActionPerform?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (actionPerform === null)
            throw new Error("The parameter 'actionPerform' cannot be null.");
        else if (actionPerform !== undefined)
            url_ += "ActionPerform=" + encodeURIComponent("" + actionPerform) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeActionPerform(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeActionPerform(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangeActionPerform(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    mergeTasks(originTaskId: string | undefined, destinationTaskId: string | undefined): Observable<GeneralTaskDto> {
        let url_ = this.baseUrl + "/api/GeneralTask/merge?";
        if (originTaskId === null)
            throw new Error("The parameter 'originTaskId' cannot be null.");
        else if (originTaskId !== undefined)
            url_ += "OriginTaskId=" + encodeURIComponent("" + originTaskId) + "&";
        if (destinationTaskId === null)
            throw new Error("The parameter 'destinationTaskId' cannot be null.");
        else if (destinationTaskId !== undefined)
            url_ += "DestinationTaskId=" + encodeURIComponent("" + destinationTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMergeTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMergeTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralTaskDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralTaskDto>;
        }));
    }

    protected processMergeTasks(response: HttpResponseBase): Observable<GeneralTaskDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralTaskDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IHangfireJobClient {
    updateJob(command: UpdateHangfireJobCommand): Observable<Unit>;
    getJobInfo(processName: string | null | undefined): Observable<JobExecutionInfoDto>;
}

@Injectable({
    providedIn: 'root'
})
export class HangfireJobClient implements IHangfireJobClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    updateJob(command: UpdateHangfireJobCommand): Observable<Unit> {
        let url_ = this.baseUrl + "/api/HangfireJob/upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Unit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Unit>;
        }));
    }

    protected processUpdateJob(response: HttpResponseBase): Observable<Unit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getJobInfo(processName: string | null | undefined): Observable<JobExecutionInfoDto> {
        let url_ = this.baseUrl + "/api/HangfireJob/getJobInfo?";
        if (processName !== undefined && processName !== null)
            url_ += "processName=" + encodeURIComponent("" + processName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobExecutionInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobExecutionInfoDto>;
        }));
    }

    protected processGetJobInfo(response: HttpResponseBase): Observable<JobExecutionInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobExecutionInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IIllustrationsClient {
    getIllustrationById(id: string | null): Observable<IllustrationRequestDto>;
    getMyOrganization(clientName: string | null | undefined, status: TasksStatus | null | undefined, subscriberId: string | null | undefined, subscriberEmail: string | null | undefined, dueDate: number | null | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<IllustrationRequestDto[]>;
    findIllustration(networkMemberIds: string[] | undefined, clientName: string | null | undefined, status: TasksStatus | null | undefined, subscriberId: string | null | undefined, subscriberEmail: string | null | undefined, dueDate: number | null | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<IllustrationRequestDto[]>;
    create(command: CreateIllustrationCommand): Observable<FileResponse>;
    reject(command: RejectIllustrationCommand): Observable<FileResponse>;
    downloadFileFromPath(taskId: string | undefined, attachmentPath: string | null | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class IllustrationsClient implements IIllustrationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getIllustrationById(id: string | null): Observable<IllustrationRequestDto> {
        let url_ = this.baseUrl + "/api/Illustrations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIllustrationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIllustrationById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IllustrationRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IllustrationRequestDto>;
        }));
    }

    protected processGetIllustrationById(response: HttpResponseBase): Observable<IllustrationRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IllustrationRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyOrganization(clientName: string | null | undefined, status: TasksStatus | null | undefined, subscriberId: string | null | undefined, subscriberEmail: string | null | undefined, dueDate: number | null | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<IllustrationRequestDto[]> {
        let url_ = this.baseUrl + "/api/Illustrations/myOrganization?";
        if (clientName !== undefined && clientName !== null)
            url_ += "ClientName=" + encodeURIComponent("" + clientName) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (subscriberId !== undefined && subscriberId !== null)
            url_ += "SubscriberId=" + encodeURIComponent("" + subscriberId) + "&";
        if (subscriberEmail !== undefined && subscriberEmail !== null)
            url_ += "SubscriberEmail=" + encodeURIComponent("" + subscriberEmail) + "&";
        if (dueDate !== undefined && dueDate !== null)
            url_ += "DueDate=" + encodeURIComponent("" + dueDate) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IllustrationRequestDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IllustrationRequestDto[]>;
        }));
    }

    protected processGetMyOrganization(response: HttpResponseBase): Observable<IllustrationRequestDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IllustrationRequestDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    findIllustration(networkMemberIds: string[] | undefined, clientName: string | null | undefined, status: TasksStatus | null | undefined, subscriberId: string | null | undefined, subscriberEmail: string | null | undefined, dueDate: number | null | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<IllustrationRequestDto[]> {
        let url_ = this.baseUrl + "/api/Illustrations/filter?";
        if (networkMemberIds === null)
            throw new Error("The parameter 'networkMemberIds' cannot be null.");
        else if (networkMemberIds !== undefined)
            networkMemberIds && networkMemberIds.forEach(item => { url_ += "NetworkMemberIds=" + encodeURIComponent("" + item) + "&"; });
        if (clientName !== undefined && clientName !== null)
            url_ += "ClientName=" + encodeURIComponent("" + clientName) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (subscriberId !== undefined && subscriberId !== null)
            url_ += "SubscriberId=" + encodeURIComponent("" + subscriberId) + "&";
        if (subscriberEmail !== undefined && subscriberEmail !== null)
            url_ += "SubscriberEmail=" + encodeURIComponent("" + subscriberEmail) + "&";
        if (dueDate !== undefined && dueDate !== null)
            url_ += "DueDate=" + encodeURIComponent("" + dueDate) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindIllustration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindIllustration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IllustrationRequestDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IllustrationRequestDto[]>;
        }));
    }

    protected processFindIllustration(response: HttpResponseBase): Observable<IllustrationRequestDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IllustrationRequestDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(command: CreateIllustrationCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Illustrations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reject(command: RejectIllustrationCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Illustrations/reject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processReject(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadFileFromPath(taskId: string | undefined, attachmentPath: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Illustrations/DownloadFromPath?";
        if (taskId === null)
            throw new Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (attachmentPath !== undefined && attachmentPath !== null)
            url_ += "AttachmentPath=" + encodeURIComponent("" + attachmentPath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFileFromPath(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFileFromPath(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDownloadFileFromPath(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface INetworkMembersClient {
    findNetworkMembersByName(name: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<AccountDto[]>;
    findNetworkMemberById(id: string | null): Observable<AccountDto>;
}

@Injectable({
    providedIn: 'root'
})
export class NetworkMembersClient implements INetworkMembersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    findNetworkMembersByName(name: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<AccountDto[]> {
        let url_ = this.baseUrl + "/api/NetworkMembers/filter?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindNetworkMembersByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindNetworkMembersByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountDto[]>;
        }));
    }

    protected processFindNetworkMembersByName(response: HttpResponseBase): Observable<AccountDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    findNetworkMemberById(id: string | null): Observable<AccountDto> {
        let url_ = this.baseUrl + "/api/NetworkMembers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindNetworkMemberById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindNetworkMemberById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountDto>;
        }));
    }

    protected processFindNetworkMemberById(response: HttpResponseBase): Observable<AccountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IOpportunityClient {
    getOpportunities(): Observable<OpportunityDto[]>;
    getOpportunitiesBySearchingId(id: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<OpportunityDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class OpportunityClient implements IOpportunityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getOpportunities(): Observable<OpportunityDto[]> {
        let url_ = this.baseUrl + "/api/Opportunity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOpportunities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOpportunities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityDto[]>;
        }));
    }

    protected processGetOpportunities(response: HttpResponseBase): Observable<OpportunityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OpportunityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOpportunitiesBySearchingId(id: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<OpportunityDto[]> {
        let url_ = this.baseUrl + "/api/Opportunity/searchingId?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOpportunitiesBySearchingId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOpportunitiesBySearchingId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityDto[]>;
        }));
    }

    protected processGetOpportunitiesBySearchingId(response: HttpResponseBase): Observable<OpportunityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OpportunityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IQuestionClient {
    getQuestions(): Observable<QuestionDto[]>;
    addQuestion(title: string | null | undefined, answer: string | null | undefined): Observable<string>;
    deleteQuestion(categoryId: string | undefined, questionId: string | undefined): Observable<Unit>;
    updateQuestion(command: UpdateQuestionCommand): Observable<Unit>;
}

@Injectable({
    providedIn: 'root'
})
export class QuestionClient implements IQuestionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getQuestions(): Observable<QuestionDto[]> {
        let url_ = this.baseUrl + "/api/Question";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuestionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuestionDto[]>;
        }));
    }

    protected processGetQuestions(response: HttpResponseBase): Observable<QuestionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuestionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addQuestion(title: string | null | undefined, answer: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Question?";
        if (title !== undefined && title !== null)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        if (answer !== undefined && answer !== null)
            url_ += "answer=" + encodeURIComponent("" + answer) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddQuestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddQuestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddQuestion(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteQuestion(categoryId: string | undefined, questionId: string | undefined): Observable<Unit> {
        let url_ = this.baseUrl + "/api/Question?";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (questionId === null)
            throw new Error("The parameter 'questionId' cannot be null.");
        else if (questionId !== undefined)
            url_ += "QuestionId=" + encodeURIComponent("" + questionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteQuestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteQuestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Unit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Unit>;
        }));
    }

    protected processDeleteQuestion(response: HttpResponseBase): Observable<Unit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateQuestion(command: UpdateQuestionCommand): Observable<Unit> {
        let url_ = this.baseUrl + "/api/Question/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateQuestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateQuestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Unit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Unit>;
        }));
    }

    protected processUpdateQuestion(response: HttpResponseBase): Observable<Unit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReportingClient {
    getToken(reportName: string | null | undefined): Observable<EmbedParamsDTO>;
    getReportsName(): Observable<PowerBiReportDetails[]>;
    getReportAccessRolesByCategory(category: SettingCategory): Observable<ReportAccessRoles[]>;
    getSettingsByName(name: string | null): Observable<ReportAccessRoles>;
    createSettings(newReportSettings: NewPowerBiReportSettings): Observable<ReportAccessRoles>;
}

@Injectable({
    providedIn: 'root'
})
export class ReportingClient implements IReportingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getToken(reportName: string | null | undefined): Observable<EmbedParamsDTO> {
        let url_ = this.baseUrl + "/api/Reporting/token?";
        if (reportName !== undefined && reportName !== null)
            url_ += "ReportName=" + encodeURIComponent("" + reportName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmbedParamsDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmbedParamsDTO>;
        }));
    }

    protected processGetToken(response: HttpResponseBase): Observable<EmbedParamsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmbedParamsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReportsName(): Observable<PowerBiReportDetails[]> {
        let url_ = this.baseUrl + "/api/Reporting/reports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportsName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportsName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PowerBiReportDetails[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PowerBiReportDetails[]>;
        }));
    }

    protected processGetReportsName(response: HttpResponseBase): Observable<PowerBiReportDetails[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PowerBiReportDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReportAccessRolesByCategory(category: SettingCategory): Observable<ReportAccessRoles[]> {
        let url_ = this.baseUrl + "/api/Reporting/settings/category/{category}";
        if (category === undefined || category === null)
            throw new Error("The parameter 'category' must be defined.");
        url_ = url_.replace("{category}", encodeURIComponent("" + category));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportAccessRolesByCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportAccessRolesByCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportAccessRoles[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportAccessRoles[]>;
        }));
    }

    protected processGetReportAccessRolesByCategory(response: HttpResponseBase): Observable<ReportAccessRoles[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportAccessRoles.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSettingsByName(name: string | null): Observable<ReportAccessRoles> {
        let url_ = this.baseUrl + "/api/Reporting/settings/name/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettingsByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettingsByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportAccessRoles>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportAccessRoles>;
        }));
    }

    protected processGetSettingsByName(response: HttpResponseBase): Observable<ReportAccessRoles> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportAccessRoles.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createSettings(newReportSettings: NewPowerBiReportSettings): Observable<ReportAccessRoles> {
        let url_ = this.baseUrl + "/api/Reporting/settings/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newReportSettings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportAccessRoles>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportAccessRoles>;
        }));
    }

    protected processCreateSettings(response: HttpResponseBase): Observable<ReportAccessRoles> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportAccessRoles.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUsersActivitiesClient {
    logUserActivity(userAction: string | null | undefined, userId: string | null | undefined, email: string | null | undefined, path: string | null | undefined, taskId: string | null | undefined, processId: string | null | undefined): Observable<string>;
    getUsersActivities(fromDate: Date | undefined, toDate: Date | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<UserActivityDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class UsersActivitiesClient implements IUsersActivitiesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    logUserActivity(userAction: string | null | undefined, userId: string | null | undefined, email: string | null | undefined, path: string | null | undefined, taskId: string | null | undefined, processId: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/UsersActivities/activity?";
        if (userAction !== undefined && userAction !== null)
            url_ += "UserAction=" + encodeURIComponent("" + userAction) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (path !== undefined && path !== null)
            url_ += "Path=" + encodeURIComponent("" + path) + "&";
        if (taskId !== undefined && taskId !== null)
            url_ += "TaskId=" + encodeURIComponent("" + taskId) + "&";
        if (processId !== undefined && processId !== null)
            url_ += "ProcessId=" + encodeURIComponent("" + processId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogUserActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogUserActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processLogUserActivity(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUsersActivities(fromDate: Date | undefined, toDate: Date | undefined, pageNumber: number | undefined, pageSize: number | undefined): Observable<UserActivityDto[]> {
        let url_ = this.baseUrl + "/api/UsersActivities/getUsersActivities?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserActivityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserActivityDto[]>;
        }));
    }

    protected processGetUsersActivities(response: HttpResponseBase): Observable<UserActivityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserActivityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

/** Represents a void type, since Void is not a valid return type in C#. */
export class Unit implements IUnit {

    constructor(data?: IUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Unit {
        data = typeof data === 'object' ? data : {};
        let result = new Unit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** Represents a void type, since Void is not a valid return type in C#. */
export interface IUnit {
}

export enum NotificationFrequency {
    Daily = 1,
    Weekly = 2,
    Instantly = 3,
    Scheduled = 4,
    Ignore = 5,
    Reccurent = 6,
}

export class EmailContact implements IEmailContact {
    illustrationRevisionId?: string;
    toEmails?: string[];
    ccEmails?: string[];

    constructor(data?: IEmailContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.illustrationRevisionId = _data["illustrationRevisionId"];
            if (Array.isArray(_data["toEmails"])) {
                this.toEmails = [] as any;
                for (let item of _data["toEmails"])
                    this.toEmails!.push(item);
            }
            if (Array.isArray(_data["ccEmails"])) {
                this.ccEmails = [] as any;
                for (let item of _data["ccEmails"])
                    this.ccEmails!.push(item);
            }
        }
    }

    static fromJS(data: any): EmailContact {
        data = typeof data === 'object' ? data : {};
        let result = new EmailContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["illustrationRevisionId"] = this.illustrationRevisionId;
        if (Array.isArray(this.toEmails)) {
            data["toEmails"] = [];
            for (let item of this.toEmails)
                data["toEmails"].push(item);
        }
        if (Array.isArray(this.ccEmails)) {
            data["ccEmails"] = [];
            for (let item of this.ccEmails)
                data["ccEmails"].push(item);
        }
        return data;
    }
}

export interface IEmailContact {
    illustrationRevisionId?: string;
    toEmails?: string[];
    ccEmails?: string[];
}

export abstract class AuditableEntity implements IAuditableEntity {
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;

    constructor(data?: IAuditableEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }

    static fromJS(data: any): AuditableEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'AuditableEntity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
}

export interface IAuditableEntity {
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export class NotificationDto extends AuditableEntity implements INotificationDto {
    id?: string;
    subject?: string;
    message?: string;
    status?: NotificationStatus;
    discussionId?: string;
    commentId?: string;
    processId?: string | undefined;
    notificationFrequency?: NotificationFrequency;
    notificationType?: NotificationType;
    emailMessage?: EmailMessageDto | undefined;
    userStatus?: UserStatus | undefined;
    occurencyDaysNumber?: number;

    constructor(data?: INotificationDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.subject = _data["subject"];
            this.message = _data["message"];
            this.status = _data["status"];
            this.discussionId = _data["discussionId"];
            this.commentId = _data["commentId"];
            this.processId = _data["processId"];
            this.notificationFrequency = _data["notificationFrequency"];
            this.notificationType = _data["notificationType"];
            this.emailMessage = _data["emailMessage"] ? EmailMessageDto.fromJS(_data["emailMessage"]) : <any>undefined;
            this.userStatus = _data["userStatus"] ? UserStatus.fromJS(_data["userStatus"]) : <any>undefined;
            this.occurencyDaysNumber = _data["occurencyDaysNumber"];
        }
    }

    static fromJS(data: any): NotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subject"] = this.subject;
        data["message"] = this.message;
        data["status"] = this.status;
        data["discussionId"] = this.discussionId;
        data["commentId"] = this.commentId;
        data["processId"] = this.processId;
        data["notificationFrequency"] = this.notificationFrequency;
        data["notificationType"] = this.notificationType;
        data["emailMessage"] = this.emailMessage ? this.emailMessage.toJSON() : <any>undefined;
        data["userStatus"] = this.userStatus ? this.userStatus.toJSON() : <any>undefined;
        data["occurencyDaysNumber"] = this.occurencyDaysNumber;
        super.toJSON(data);
        return data;
    }
}

export interface INotificationDto extends IAuditableEntity {
    id?: string;
    subject?: string;
    message?: string;
    status?: NotificationStatus;
    discussionId?: string;
    commentId?: string;
    processId?: string | undefined;
    notificationFrequency?: NotificationFrequency;
    notificationType?: NotificationType;
    emailMessage?: EmailMessageDto | undefined;
    userStatus?: UserStatus | undefined;
    occurencyDaysNumber?: number;
}

export enum NotificationStatus {
    New = 0,
    Read = 1,
    Unread = 2,
    Deleted = 3,
    Sent = 4,
    Stopped = 5,
}

export enum NotificationType {
    EmailNotification = 0,
    WebNotification = 1,
    SmsNotification = 2,
}

export class EmailMessageDto implements IEmailMessageDto {
    recipientsId?: string[];
    recipientsEmail?: string[];
    ccRecipientsId?: string[];
    ccRecipientsEmails?: string[];
    subject?: string;
    introduction?: string;
    buttonText?: string;
    buttonLink?: string;
    afterButtonText?: string;
    footer?: string;
    attachments?: UploadFileDto[];

    constructor(data?: IEmailMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["recipientsId"])) {
                this.recipientsId = [] as any;
                for (let item of _data["recipientsId"])
                    this.recipientsId!.push(item);
            }
            if (Array.isArray(_data["recipientsEmail"])) {
                this.recipientsEmail = [] as any;
                for (let item of _data["recipientsEmail"])
                    this.recipientsEmail!.push(item);
            }
            if (Array.isArray(_data["ccRecipientsId"])) {
                this.ccRecipientsId = [] as any;
                for (let item of _data["ccRecipientsId"])
                    this.ccRecipientsId!.push(item);
            }
            if (Array.isArray(_data["ccRecipientsEmails"])) {
                this.ccRecipientsEmails = [] as any;
                for (let item of _data["ccRecipientsEmails"])
                    this.ccRecipientsEmails!.push(item);
            }
            this.subject = _data["subject"];
            this.introduction = _data["introduction"];
            this.buttonText = _data["buttonText"];
            this.buttonLink = _data["buttonLink"];
            this.afterButtonText = _data["afterButtonText"];
            this.footer = _data["footer"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(UploadFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmailMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recipientsId)) {
            data["recipientsId"] = [];
            for (let item of this.recipientsId)
                data["recipientsId"].push(item);
        }
        if (Array.isArray(this.recipientsEmail)) {
            data["recipientsEmail"] = [];
            for (let item of this.recipientsEmail)
                data["recipientsEmail"].push(item);
        }
        if (Array.isArray(this.ccRecipientsId)) {
            data["ccRecipientsId"] = [];
            for (let item of this.ccRecipientsId)
                data["ccRecipientsId"].push(item);
        }
        if (Array.isArray(this.ccRecipientsEmails)) {
            data["ccRecipientsEmails"] = [];
            for (let item of this.ccRecipientsEmails)
                data["ccRecipientsEmails"].push(item);
        }
        data["subject"] = this.subject;
        data["introduction"] = this.introduction;
        data["buttonText"] = this.buttonText;
        data["buttonLink"] = this.buttonLink;
        data["afterButtonText"] = this.afterButtonText;
        data["footer"] = this.footer;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmailMessageDto {
    recipientsId?: string[];
    recipientsEmail?: string[];
    ccRecipientsId?: string[];
    ccRecipientsEmails?: string[];
    subject?: string;
    introduction?: string;
    buttonText?: string;
    buttonLink?: string;
    afterButtonText?: string;
    footer?: string;
    attachments?: UploadFileDto[];
}

export class UploadFileDto implements IUploadFileDto {
    file?: string;
    fileName?: string;
    fileType?: string;
    fileDate?: Date;

    constructor(data?: IUploadFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"];
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileDate = _data["fileDate"] ? new Date(_data["fileDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UploadFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileDate"] = this.fileDate ? this.fileDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUploadFileDto {
    file?: string;
    fileName?: string;
    fileType?: string;
    fileDate?: Date;
}

export class UserStatus implements IUserStatus {
    userId?: string;
    status?: NotificationStatus;
    modifiedDateTime?: Date;

    constructor(data?: IUserStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.status = _data["status"];
            this.modifiedDateTime = _data["modifiedDateTime"] ? new Date(_data["modifiedDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserStatus {
        data = typeof data === 'object' ? data : {};
        let result = new UserStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["status"] = this.status;
        data["modifiedDateTime"] = this.modifiedDateTime ? this.modifiedDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserStatus {
    userId?: string;
    status?: NotificationStatus;
    modifiedDateTime?: Date;
}

export class UpdateEmailNotificationsStatusCommand implements IUpdateEmailNotificationsStatusCommand {
    notificationIds?: string[];
    status?: NotificationStatus;

    constructor(data?: IUpdateEmailNotificationsStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["notificationIds"])) {
                this.notificationIds = [] as any;
                for (let item of _data["notificationIds"])
                    this.notificationIds!.push(item);
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateEmailNotificationsStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmailNotificationsStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notificationIds)) {
            data["notificationIds"] = [];
            for (let item of this.notificationIds)
                data["notificationIds"].push(item);
        }
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateEmailNotificationsStatusCommand {
    notificationIds?: string[];
    status?: NotificationStatus;
}

export class UpdateNotificationStatusByCommentIdCommand implements IUpdateNotificationStatusByCommentIdCommand {
    commentId?: string;
    status?: NotificationStatus;

    constructor(data?: IUpdateNotificationStatusByCommentIdCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commentId = _data["commentId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateNotificationStatusByCommentIdCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNotificationStatusByCommentIdCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commentId"] = this.commentId;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateNotificationStatusByCommentIdCommand {
    commentId?: string;
    status?: NotificationStatus;
}

export class UserDto implements IUserDto {
    id?: string;
    sourceId?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    preferredEmail?: string;
    networkMemberId?: string;
    networkMemberIds?: string[];
    clientId?: string;
    active?: boolean;
    isFinancial?: boolean | undefined;
    invitatedToAzure?: boolean;
    crmSourceId?: string;
    isPrimary?: boolean;
    contactMailing?: string;
    termsAndConditions?: Consent;
    privacyNotices?: Consent;
    roles?: string[];
    reportsAccessRoles?: string[];

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceId = _data["sourceId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.preferredEmail = _data["preferredEmail"];
            this.networkMemberId = _data["networkMemberId"];
            if (Array.isArray(_data["networkMemberIds"])) {
                this.networkMemberIds = [] as any;
                for (let item of _data["networkMemberIds"])
                    this.networkMemberIds!.push(item);
            }
            this.clientId = _data["clientId"];
            this.active = _data["active"];
            this.isFinancial = _data["isFinancial"];
            this.invitatedToAzure = _data["invitatedToAzure"];
            this.crmSourceId = _data["crmSourceId"];
            this.isPrimary = _data["isPrimary"];
            this.contactMailing = _data["contactMailing"];
            this.termsAndConditions = _data["termsAndConditions"] ? Consent.fromJS(_data["termsAndConditions"]) : <any>undefined;
            this.privacyNotices = _data["privacyNotices"] ? Consent.fromJS(_data["privacyNotices"]) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["reportsAccessRoles"])) {
                this.reportsAccessRoles = [] as any;
                for (let item of _data["reportsAccessRoles"])
                    this.reportsAccessRoles!.push(item);
            }
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceId"] = this.sourceId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["preferredEmail"] = this.preferredEmail;
        data["networkMemberId"] = this.networkMemberId;
        if (Array.isArray(this.networkMemberIds)) {
            data["networkMemberIds"] = [];
            for (let item of this.networkMemberIds)
                data["networkMemberIds"].push(item);
        }
        data["clientId"] = this.clientId;
        data["active"] = this.active;
        data["isFinancial"] = this.isFinancial;
        data["invitatedToAzure"] = this.invitatedToAzure;
        data["crmSourceId"] = this.crmSourceId;
        data["isPrimary"] = this.isPrimary;
        data["contactMailing"] = this.contactMailing;
        data["termsAndConditions"] = this.termsAndConditions ? this.termsAndConditions.toJSON() : <any>undefined;
        data["privacyNotices"] = this.privacyNotices ? this.privacyNotices.toJSON() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.reportsAccessRoles)) {
            data["reportsAccessRoles"] = [];
            for (let item of this.reportsAccessRoles)
                data["reportsAccessRoles"].push(item);
        }
        return data;
    }
}

export interface IUserDto {
    id?: string;
    sourceId?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    preferredEmail?: string;
    networkMemberId?: string;
    networkMemberIds?: string[];
    clientId?: string;
    active?: boolean;
    isFinancial?: boolean | undefined;
    invitatedToAzure?: boolean;
    crmSourceId?: string;
    isPrimary?: boolean;
    contactMailing?: string;
    termsAndConditions?: Consent;
    privacyNotices?: Consent;
    roles?: string[];
    reportsAccessRoles?: string[];
}

export class Consent implements IConsent {
    isMandatory?: boolean;
    approved?: boolean;
    approvedDate?: Date | undefined;
    version?: string | undefined;

    constructor(data?: IConsent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isMandatory = _data["isMandatory"];
            this.approved = _data["approved"];
            this.approvedDate = _data["approvedDate"] ? new Date(_data["approvedDate"].toString()) : <any>undefined;
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): Consent {
        data = typeof data === 'object' ? data : {};
        let result = new Consent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isMandatory"] = this.isMandatory;
        data["approved"] = this.approved;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["version"] = this.version;
        return data;
    }
}

export interface IConsent {
    isMandatory?: boolean;
    approved?: boolean;
    approvedDate?: Date | undefined;
    version?: string | undefined;
}

export class UpsertUserCommand implements IUpsertUserCommand {
    sourceId?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    preferredEmail?: string;
    networkMemberId?: string;
    networkMemberIds?: string[];
    termsAndCondition?: Consent;
    privacyNotice?: Consent;
    active?: boolean;
    isFinancial?: boolean | undefined;
    invitatedToAzure?: boolean;
    roles?: string[];
    reportsAccessRoles?: string[];

    constructor(data?: IUpsertUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.preferredEmail = _data["preferredEmail"];
            this.networkMemberId = _data["networkMemberId"];
            if (Array.isArray(_data["networkMemberIds"])) {
                this.networkMemberIds = [] as any;
                for (let item of _data["networkMemberIds"])
                    this.networkMemberIds!.push(item);
            }
            this.termsAndCondition = _data["termsAndCondition"] ? Consent.fromJS(_data["termsAndCondition"]) : <any>undefined;
            this.privacyNotice = _data["privacyNotice"] ? Consent.fromJS(_data["privacyNotice"]) : <any>undefined;
            this.active = _data["active"];
            this.isFinancial = _data["isFinancial"];
            this.invitatedToAzure = _data["invitatedToAzure"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["reportsAccessRoles"])) {
                this.reportsAccessRoles = [] as any;
                for (let item of _data["reportsAccessRoles"])
                    this.reportsAccessRoles!.push(item);
            }
        }
    }

    static fromJS(data: any): UpsertUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["preferredEmail"] = this.preferredEmail;
        data["networkMemberId"] = this.networkMemberId;
        if (Array.isArray(this.networkMemberIds)) {
            data["networkMemberIds"] = [];
            for (let item of this.networkMemberIds)
                data["networkMemberIds"].push(item);
        }
        data["termsAndCondition"] = this.termsAndCondition ? this.termsAndCondition.toJSON() : <any>undefined;
        data["privacyNotice"] = this.privacyNotice ? this.privacyNotice.toJSON() : <any>undefined;
        data["active"] = this.active;
        data["isFinancial"] = this.isFinancial;
        data["invitatedToAzure"] = this.invitatedToAzure;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.reportsAccessRoles)) {
            data["reportsAccessRoles"] = [];
            for (let item of this.reportsAccessRoles)
                data["reportsAccessRoles"].push(item);
        }
        return data;
    }
}

export interface IUpsertUserCommand {
    sourceId?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    preferredEmail?: string;
    networkMemberId?: string;
    networkMemberIds?: string[];
    termsAndCondition?: Consent;
    privacyNotice?: Consent;
    active?: boolean;
    isFinancial?: boolean | undefined;
    invitatedToAzure?: boolean;
    roles?: string[];
    reportsAccessRoles?: string[];
}

export class UpdateUserConsentsCommand implements IUpdateUserConsentsCommand {
    userId?: string;
    termsAndConditions?: Consent;
    privacyNotice?: Consent;

    constructor(data?: IUpdateUserConsentsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.termsAndConditions = _data["termsAndConditions"] ? Consent.fromJS(_data["termsAndConditions"]) : <any>undefined;
            this.privacyNotice = _data["privacyNotice"] ? Consent.fromJS(_data["privacyNotice"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateUserConsentsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserConsentsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["termsAndConditions"] = this.termsAndConditions ? this.termsAndConditions.toJSON() : <any>undefined;
        data["privacyNotice"] = this.privacyNotice ? this.privacyNotice.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateUserConsentsCommand {
    userId?: string;
    termsAndConditions?: Consent;
    privacyNotice?: Consent;
}

export class AccountDto implements IAccountDto {
    id?: string;
    accountName?: string;
    type?: string;
    status?: string;
    currencyCode?: string;
    isAdl?: boolean;
    externalAccountNumber?: string;
    email?: string;
    mainPhone?: string;
    webAddress?: string;
    countries?: CountryDto[];
    accountX?: AccountXesDto;
    accountManager?: AccountManagerDto;
    divisionalManager?: DivisionalManagerDto;

    constructor(data?: IAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountName = _data["accountName"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.currencyCode = _data["currencyCode"];
            this.isAdl = _data["isAdl"];
            this.externalAccountNumber = _data["externalAccountNumber"];
            this.email = _data["email"];
            this.mainPhone = _data["mainPhone"];
            this.webAddress = _data["webAddress"];
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(CountryDto.fromJS(item));
            }
            this.accountX = _data["accountX"] ? AccountXesDto.fromJS(_data["accountX"]) : <any>undefined;
            this.accountManager = _data["accountManager"] ? AccountManagerDto.fromJS(_data["accountManager"]) : <any>undefined;
            this.divisionalManager = _data["divisionalManager"] ? DivisionalManagerDto.fromJS(_data["divisionalManager"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountName"] = this.accountName;
        data["type"] = this.type;
        data["status"] = this.status;
        data["currencyCode"] = this.currencyCode;
        data["isAdl"] = this.isAdl;
        data["externalAccountNumber"] = this.externalAccountNumber;
        data["email"] = this.email;
        data["mainPhone"] = this.mainPhone;
        data["webAddress"] = this.webAddress;
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        data["accountX"] = this.accountX ? this.accountX.toJSON() : <any>undefined;
        data["accountManager"] = this.accountManager ? this.accountManager.toJSON() : <any>undefined;
        data["divisionalManager"] = this.divisionalManager ? this.divisionalManager.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAccountDto {
    id?: string;
    accountName?: string;
    type?: string;
    status?: string;
    currencyCode?: string;
    isAdl?: boolean;
    externalAccountNumber?: string;
    email?: string;
    mainPhone?: string;
    webAddress?: string;
    countries?: CountryDto[];
    accountX?: AccountXesDto;
    accountManager?: AccountManagerDto;
    divisionalManager?: DivisionalManagerDto;
}

export class CountryDto implements ICountryDto {
    countryId?: string;
    name?: string;
    iso2?: string;

    constructor(data?: ICountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.name = _data["name"];
            this.iso2 = _data["iso2"];
        }
    }

    static fromJS(data: any): CountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["name"] = this.name;
        data["iso2"] = this.iso2;
        return data;
    }
}

export interface ICountryDto {
    countryId?: string;
    name?: string;
    iso2?: string;
}

export class AccountXesDto implements IAccountXesDto {
    id?: string;
    systems?: string;
    pooldate?: Date;
    dividend?: string;
    last_Account?: string;
    lives?: string;
    premium?: number;
    poolComments?: string;
    result?: number;
    carry_forward_result?: number;
    currentPooledCountries?: number;
    currentPRCountries?: number;

    constructor(data?: IAccountXesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.systems = _data["systems"];
            this.pooldate = _data["pooldate"] ? new Date(_data["pooldate"].toString()) : <any>undefined;
            this.dividend = _data["dividend"];
            this.last_Account = _data["last_Account"];
            this.lives = _data["lives"];
            this.premium = _data["premium"];
            this.poolComments = _data["poolComments"];
            this.result = _data["result"];
            this.carry_forward_result = _data["carry_forward_result"];
            this.currentPooledCountries = _data["currentPooledCountries"];
            this.currentPRCountries = _data["currentPRCountries"];
        }
    }

    static fromJS(data: any): AccountXesDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountXesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["systems"] = this.systems;
        data["pooldate"] = this.pooldate ? this.pooldate.toISOString() : <any>undefined;
        data["dividend"] = this.dividend;
        data["last_Account"] = this.last_Account;
        data["lives"] = this.lives;
        data["premium"] = this.premium;
        data["poolComments"] = this.poolComments;
        data["result"] = this.result;
        data["carry_forward_result"] = this.carry_forward_result;
        data["currentPooledCountries"] = this.currentPooledCountries;
        data["currentPRCountries"] = this.currentPRCountries;
        return data;
    }
}

export interface IAccountXesDto {
    id?: string;
    systems?: string;
    pooldate?: Date;
    dividend?: string;
    last_Account?: string;
    lives?: string;
    premium?: number;
    poolComments?: string;
    result?: number;
    carry_forward_result?: number;
    currentPooledCountries?: number;
    currentPRCountries?: number;
}

export class AccountManagerDto implements IAccountManagerDto {
    id?: string;
    userInfo?: UserInfoDto;

    constructor(data?: IAccountManagerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userInfo = _data["userInfo"] ? UserInfoDto.fromJS(_data["userInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AccountManagerDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountManagerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userInfo"] = this.userInfo ? this.userInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAccountManagerDto {
    id?: string;
    userInfo?: UserInfoDto;
}

export class UserInfoDto implements IUserInfoDto {
    id?: string;
    descriptor?: string;
    department?: string;
    division?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    mobile?: any;
    phone?: string;
    region?: string;
    title?: string;
    userName?: string;
    address?: AddressDto;

    constructor(data?: IUserInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.descriptor = _data["descriptor"];
            this.department = _data["department"];
            this.division = _data["division"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.mobile = _data["mobile"];
            this.phone = _data["phone"];
            this.region = _data["region"];
            this.title = _data["title"];
            this.userName = _data["userName"];
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["descriptor"] = this.descriptor;
        data["department"] = this.department;
        data["division"] = this.division;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["mobile"] = this.mobile;
        data["phone"] = this.phone;
        data["region"] = this.region;
        data["title"] = this.title;
        data["userName"] = this.userName;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserInfoDto {
    id?: string;
    descriptor?: string;
    department?: string;
    division?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    mobile?: any;
    phone?: string;
    region?: string;
    title?: string;
    userName?: string;
    address?: AddressDto;
}

export class AddressDto implements IAddressDto {
    id?: string;
    countryCode?: string;
    country?: string;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.countryCode = _data["countryCode"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["countryCode"] = this.countryCode;
        data["country"] = this.country;
        return data;
    }
}

export interface IAddressDto {
    id?: string;
    countryCode?: string;
    country?: string;
}

export class DivisionalManagerDto implements IDivisionalManagerDto {
    id?: string;
    userInfo?: UserInfoDto;

    constructor(data?: IDivisionalManagerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userInfo = _data["userInfo"] ? UserInfoDto.fromJS(_data["userInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DivisionalManagerDto {
        data = typeof data === 'object' ? data : {};
        let result = new DivisionalManagerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userInfo"] = this.userInfo ? this.userInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDivisionalManagerDto {
    id?: string;
    userInfo?: UserInfoDto;
}

export class TechnicalContact implements ITechnicalContact {
    name?: string;
    email?: string;
    phone?: string;

    constructor(data?: ITechnicalContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): TechnicalContact {
        data = typeof data === 'object' ? data : {};
        let result = new TechnicalContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface ITechnicalContact {
    name?: string;
    email?: string;
    phone?: string;
}

export class PaginatedListOfExpansionPlanDto implements IPaginatedListOfExpansionPlanDto {
    items?: ExpansionPlanDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfExpansionPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExpansionPlanDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfExpansionPlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfExpansionPlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfExpansionPlanDto {
    items?: ExpansionPlanDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class ExpansionPlanDto implements IExpansionPlanDto {
    id?: string;
    country?: string;
    local_company_name?: string | undefined;
    status?: string;
    startDate?: Date | undefined;
    benefits?: string;
    employees?: number | undefined;
    premiumPoolCurrency?: number | undefined;
    comments?: string | undefined;
    brokerComtact?: string | undefined;
    companyContact?: string | undefined;
    insurer?: string | undefined;
    insNetwork?: string | undefined;
    account?: AccountDto;

    constructor(data?: IExpansionPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.country = _data["country"];
            this.local_company_name = _data["local_company_name"];
            this.status = _data["status"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.benefits = _data["benefits"];
            this.employees = _data["employees"];
            this.premiumPoolCurrency = _data["premiumPoolCurrency"];
            this.comments = _data["comments"];
            this.brokerComtact = _data["brokerComtact"];
            this.companyContact = _data["companyContact"];
            this.insurer = _data["insurer"];
            this.insNetwork = _data["insNetwork"];
            this.account = _data["account"] ? AccountDto.fromJS(_data["account"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExpansionPlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpansionPlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["country"] = this.country;
        data["local_company_name"] = this.local_company_name;
        data["status"] = this.status;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["benefits"] = this.benefits;
        data["employees"] = this.employees;
        data["premiumPoolCurrency"] = this.premiumPoolCurrency;
        data["comments"] = this.comments;
        data["brokerComtact"] = this.brokerComtact;
        data["companyContact"] = this.companyContact;
        data["insurer"] = this.insurer;
        data["insNetwork"] = this.insNetwork;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExpansionPlanDto {
    id?: string;
    country?: string;
    local_company_name?: string | undefined;
    status?: string;
    startDate?: Date | undefined;
    benefits?: string;
    employees?: number | undefined;
    premiumPoolCurrency?: number | undefined;
    comments?: string | undefined;
    brokerComtact?: string | undefined;
    companyContact?: string | undefined;
    insurer?: string | undefined;
    insNetwork?: string | undefined;
    account?: AccountDto;
}

export class BaseTaskDto extends AuditableEntity implements IBaseTaskDto {
    id?: string;
    sourceId?: string;
    processId?: string;
    title?: string;
    subTitle?: string;
    content?: string;
    displayDate?: Date;
    metaData?: string;
    networkMember?: AccountDto;
    networkMemberId?: string;
    clientId?: string;
    status?: Status;
    assignedTo?: AssignedTo;
    insuropeSubscribers?: string[];
    networkMemberSubscribers?: string[];
    clientSubscribers?: string[];
    adminDbAttachments?: string[];
    systemAttachments?: Attachment[];
    isOverdue?: boolean;
    isNewTask?: boolean;
    overdueDate?: Date | undefined;
    country?: string;
    actionPerform?: ActionPerform | undefined;
    actionPerformedDate?: Date | undefined;

    constructor(data?: IBaseTaskDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.sourceId = _data["sourceId"];
            this.processId = _data["processId"];
            this.title = _data["title"];
            this.subTitle = _data["subTitle"];
            this.content = _data["content"];
            this.displayDate = _data["displayDate"] ? new Date(_data["displayDate"].toString()) : <any>undefined;
            this.metaData = _data["metaData"];
            this.networkMember = _data["networkMember"] ? AccountDto.fromJS(_data["networkMember"]) : <any>undefined;
            this.networkMemberId = _data["networkMemberId"];
            this.clientId = _data["clientId"];
            this.status = _data["status"] ? Status.fromJS(_data["status"]) : <any>undefined;
            this.assignedTo = _data["assignedTo"];
            if (Array.isArray(_data["insuropeSubscribers"])) {
                this.insuropeSubscribers = [] as any;
                for (let item of _data["insuropeSubscribers"])
                    this.insuropeSubscribers!.push(item);
            }
            if (Array.isArray(_data["networkMemberSubscribers"])) {
                this.networkMemberSubscribers = [] as any;
                for (let item of _data["networkMemberSubscribers"])
                    this.networkMemberSubscribers!.push(item);
            }
            if (Array.isArray(_data["clientSubscribers"])) {
                this.clientSubscribers = [] as any;
                for (let item of _data["clientSubscribers"])
                    this.clientSubscribers!.push(item);
            }
            if (Array.isArray(_data["adminDbAttachments"])) {
                this.adminDbAttachments = [] as any;
                for (let item of _data["adminDbAttachments"])
                    this.adminDbAttachments!.push(item);
            }
            if (Array.isArray(_data["systemAttachments"])) {
                this.systemAttachments = [] as any;
                for (let item of _data["systemAttachments"])
                    this.systemAttachments!.push(Attachment.fromJS(item));
            }
            this.isOverdue = _data["isOverdue"];
            this.isNewTask = _data["isNewTask"];
            this.overdueDate = _data["overdueDate"] ? new Date(_data["overdueDate"].toString()) : <any>undefined;
            this.country = _data["country"];
            this.actionPerform = _data["actionPerform"];
            this.actionPerformedDate = _data["actionPerformedDate"] ? new Date(_data["actionPerformedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceId"] = this.sourceId;
        data["processId"] = this.processId;
        data["title"] = this.title;
        data["subTitle"] = this.subTitle;
        data["content"] = this.content;
        data["displayDate"] = this.displayDate ? this.displayDate.toISOString() : <any>undefined;
        data["metaData"] = this.metaData;
        data["networkMember"] = this.networkMember ? this.networkMember.toJSON() : <any>undefined;
        data["networkMemberId"] = this.networkMemberId;
        data["clientId"] = this.clientId;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["assignedTo"] = this.assignedTo;
        if (Array.isArray(this.insuropeSubscribers)) {
            data["insuropeSubscribers"] = [];
            for (let item of this.insuropeSubscribers)
                data["insuropeSubscribers"].push(item);
        }
        if (Array.isArray(this.networkMemberSubscribers)) {
            data["networkMemberSubscribers"] = [];
            for (let item of this.networkMemberSubscribers)
                data["networkMemberSubscribers"].push(item);
        }
        if (Array.isArray(this.clientSubscribers)) {
            data["clientSubscribers"] = [];
            for (let item of this.clientSubscribers)
                data["clientSubscribers"].push(item);
        }
        if (Array.isArray(this.adminDbAttachments)) {
            data["adminDbAttachments"] = [];
            for (let item of this.adminDbAttachments)
                data["adminDbAttachments"].push(item);
        }
        if (Array.isArray(this.systemAttachments)) {
            data["systemAttachments"] = [];
            for (let item of this.systemAttachments)
                data["systemAttachments"].push(item.toJSON());
        }
        data["isOverdue"] = this.isOverdue;
        data["isNewTask"] = this.isNewTask;
        data["overdueDate"] = this.overdueDate ? this.overdueDate.toISOString() : <any>undefined;
        data["country"] = this.country;
        data["actionPerform"] = this.actionPerform;
        data["actionPerformedDate"] = this.actionPerformedDate ? this.actionPerformedDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IBaseTaskDto extends IAuditableEntity {
    id?: string;
    sourceId?: string;
    processId?: string;
    title?: string;
    subTitle?: string;
    content?: string;
    displayDate?: Date;
    metaData?: string;
    networkMember?: AccountDto;
    networkMemberId?: string;
    clientId?: string;
    status?: Status;
    assignedTo?: AssignedTo;
    insuropeSubscribers?: string[];
    networkMemberSubscribers?: string[];
    clientSubscribers?: string[];
    adminDbAttachments?: string[];
    systemAttachments?: Attachment[];
    isOverdue?: boolean;
    isNewTask?: boolean;
    overdueDate?: Date | undefined;
    country?: string;
    actionPerform?: ActionPerform | undefined;
    actionPerformedDate?: Date | undefined;
}

export class BooleanTaskDto extends BaseTaskDto implements IBooleanTaskDto {
    value?: boolean | undefined;
    streamAttachments?: Stream[];
    approvalDate?: Date | undefined;
    inputRcvdDate?: Date | undefined;
    firstCheckedDate?: Date | undefined;

    constructor(data?: IBooleanTaskDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
            if (Array.isArray(_data["streamAttachments"])) {
                this.streamAttachments = [] as any;
                for (let item of _data["streamAttachments"])
                    this.streamAttachments!.push(Stream.fromJS(item));
            }
            this.approvalDate = _data["approvalDate"] ? new Date(_data["approvalDate"].toString()) : <any>undefined;
            this.inputRcvdDate = _data["inputRcvdDate"] ? new Date(_data["inputRcvdDate"].toString()) : <any>undefined;
            this.firstCheckedDate = _data["firstCheckedDate"] ? new Date(_data["firstCheckedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BooleanTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        if (Array.isArray(this.streamAttachments)) {
            data["streamAttachments"] = [];
            for (let item of this.streamAttachments)
                data["streamAttachments"].push(item.toJSON());
        }
        data["approvalDate"] = this.approvalDate ? this.approvalDate.toISOString() : <any>undefined;
        data["inputRcvdDate"] = this.inputRcvdDate ? this.inputRcvdDate.toISOString() : <any>undefined;
        data["firstCheckedDate"] = this.firstCheckedDate ? this.firstCheckedDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IBooleanTaskDto extends IBaseTaskDto {
    value?: boolean | undefined;
    streamAttachments?: Stream[];
    approvalDate?: Date | undefined;
    inputRcvdDate?: Date | undefined;
    firstCheckedDate?: Date | undefined;
}

export abstract class MarshalByRefObject implements IMarshalByRefObject {

    constructor(data?: IMarshalByRefObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): MarshalByRefObject {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MarshalByRefObject' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IMarshalByRefObject {
}

export abstract class Stream extends MarshalByRefObject implements IStream {
    canTimeout?: boolean;
    readTimeout?: number;
    writeTimeout?: number;

    constructor(data?: IStream) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.canTimeout = _data["canTimeout"];
            this.readTimeout = _data["readTimeout"];
            this.writeTimeout = _data["writeTimeout"];
        }
    }

    static fromJS(data: any): Stream {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Stream' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canTimeout"] = this.canTimeout;
        data["readTimeout"] = this.readTimeout;
        data["writeTimeout"] = this.writeTimeout;
        super.toJSON(data);
        return data;
    }
}

export interface IStream extends IMarshalByRefObject {
    canTimeout?: boolean;
    readTimeout?: number;
    writeTimeout?: number;
}

export class Status implements IStatus {
    value?: TasksStatus;
    sortOrder?: number;

    constructor(data?: IStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): Status {
        data = typeof data === 'object' ? data : {};
        let result = new Status();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IStatus {
    value?: TasksStatus;
    sortOrder?: number;
}

export enum TasksStatus {
    Open = 0,
    Closed = 1,
    OnHold = 2,
    WaitingForInput = 3,
    IsDeleted = 4,
    Hidden = 5,
    Finalized = 6,
    InProgress = 7,
    All = 8,
}

export enum AssignedTo {
    NetworkMember = 0,
    Internal = 1,
    Client = 2,
}

export class Attachment implements IAttachment {
    id?: string;
    name?: string;
    path?: string;
    fileType?: string;
    checkSum?: string;
    fileDate?: Date;
    commentId?: string;

    constructor(data?: IAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.path = _data["path"];
            this.fileType = _data["fileType"];
            this.checkSum = _data["checkSum"];
            this.fileDate = _data["fileDate"] ? new Date(_data["fileDate"].toString()) : <any>undefined;
            this.commentId = _data["commentId"];
        }
    }

    static fromJS(data: any): Attachment {
        data = typeof data === 'object' ? data : {};
        let result = new Attachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["path"] = this.path;
        data["fileType"] = this.fileType;
        data["checkSum"] = this.checkSum;
        data["fileDate"] = this.fileDate ? this.fileDate.toISOString() : <any>undefined;
        data["commentId"] = this.commentId;
        return data;
    }
}

export interface IAttachment {
    id?: string;
    name?: string;
    path?: string;
    fileType?: string;
    checkSum?: string;
    fileDate?: Date;
    commentId?: string;
}

export enum ActionPerform {
    MarkAsNotDone = 0,
    MarkAsDone = 1,
}

export enum PayToEnum {
    Null = 0,
    Insurope = 1,
    Client = 2,
    Other = 3,
}

export class SortingElement implements ISortingElement {
    columnName?: string;
    sortOrder?: SortOrder;

    constructor(data?: ISortingElement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.columnName = _data["columnName"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): SortingElement {
        data = typeof data === 'object' ? data : {};
        let result = new SortingElement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["columnName"] = this.columnName;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface ISortingElement {
    columnName?: string;
    sortOrder?: SortOrder;
}

export enum SortOrder {
    Ascending = 0,
    Descending = 1,
}

export class UpsertBooleanTaskDto implements IUpsertBooleanTaskDto {
    title?: string;
    subTitle?: string;
    content?: string;
    sourceId?: string;
    displayDate?: string;
    processId?: string;
    metaData?: string;
    value?: boolean | undefined;
    networkMemberId?: string;
    clientId?: string;
    status?: Status;
    streamAttachments?: Stream[];
    adminDbAttachments?: string[];
    insuropeSubscribers?: string[];
    networkMemberSubscribers?: string[];
    clientSubscribers?: string[];
    isOverdue?: boolean;
    overdueDate?: string | undefined;
    approvalDate?: string | undefined;
    inputRcvdDate?: string | undefined;
    firstCheckedDate?: Date | undefined;
    country?: string;

    constructor(data?: IUpsertBooleanTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.subTitle = _data["subTitle"];
            this.content = _data["content"];
            this.sourceId = _data["sourceId"];
            this.displayDate = _data["displayDate"];
            this.processId = _data["processId"];
            this.metaData = _data["metaData"];
            this.value = _data["value"];
            this.networkMemberId = _data["networkMemberId"];
            this.clientId = _data["clientId"];
            this.status = _data["status"] ? Status.fromJS(_data["status"]) : <any>undefined;
            if (Array.isArray(_data["streamAttachments"])) {
                this.streamAttachments = [] as any;
                for (let item of _data["streamAttachments"])
                    this.streamAttachments!.push(Stream.fromJS(item));
            }
            if (Array.isArray(_data["adminDbAttachments"])) {
                this.adminDbAttachments = [] as any;
                for (let item of _data["adminDbAttachments"])
                    this.adminDbAttachments!.push(item);
            }
            if (Array.isArray(_data["insuropeSubscribers"])) {
                this.insuropeSubscribers = [] as any;
                for (let item of _data["insuropeSubscribers"])
                    this.insuropeSubscribers!.push(item);
            }
            if (Array.isArray(_data["networkMemberSubscribers"])) {
                this.networkMemberSubscribers = [] as any;
                for (let item of _data["networkMemberSubscribers"])
                    this.networkMemberSubscribers!.push(item);
            }
            if (Array.isArray(_data["clientSubscribers"])) {
                this.clientSubscribers = [] as any;
                for (let item of _data["clientSubscribers"])
                    this.clientSubscribers!.push(item);
            }
            this.isOverdue = _data["isOverdue"];
            this.overdueDate = _data["overdueDate"];
            this.approvalDate = _data["approvalDate"];
            this.inputRcvdDate = _data["inputRcvdDate"];
            this.firstCheckedDate = _data["firstCheckedDate"] ? new Date(_data["firstCheckedDate"].toString()) : <any>undefined;
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): UpsertBooleanTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertBooleanTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["subTitle"] = this.subTitle;
        data["content"] = this.content;
        data["sourceId"] = this.sourceId;
        data["displayDate"] = this.displayDate;
        data["processId"] = this.processId;
        data["metaData"] = this.metaData;
        data["value"] = this.value;
        data["networkMemberId"] = this.networkMemberId;
        data["clientId"] = this.clientId;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        if (Array.isArray(this.streamAttachments)) {
            data["streamAttachments"] = [];
            for (let item of this.streamAttachments)
                data["streamAttachments"].push(item.toJSON());
        }
        if (Array.isArray(this.adminDbAttachments)) {
            data["adminDbAttachments"] = [];
            for (let item of this.adminDbAttachments)
                data["adminDbAttachments"].push(item);
        }
        if (Array.isArray(this.insuropeSubscribers)) {
            data["insuropeSubscribers"] = [];
            for (let item of this.insuropeSubscribers)
                data["insuropeSubscribers"].push(item);
        }
        if (Array.isArray(this.networkMemberSubscribers)) {
            data["networkMemberSubscribers"] = [];
            for (let item of this.networkMemberSubscribers)
                data["networkMemberSubscribers"].push(item);
        }
        if (Array.isArray(this.clientSubscribers)) {
            data["clientSubscribers"] = [];
            for (let item of this.clientSubscribers)
                data["clientSubscribers"].push(item);
        }
        data["isOverdue"] = this.isOverdue;
        data["overdueDate"] = this.overdueDate;
        data["approvalDate"] = this.approvalDate;
        data["inputRcvdDate"] = this.inputRcvdDate;
        data["firstCheckedDate"] = this.firstCheckedDate ? this.firstCheckedDate.toISOString() : <any>undefined;
        data["country"] = this.country;
        return data;
    }
}

export interface IUpsertBooleanTaskDto {
    title?: string;
    subTitle?: string;
    content?: string;
    sourceId?: string;
    displayDate?: string;
    processId?: string;
    metaData?: string;
    value?: boolean | undefined;
    networkMemberId?: string;
    clientId?: string;
    status?: Status;
    streamAttachments?: Stream[];
    adminDbAttachments?: string[];
    insuropeSubscribers?: string[];
    networkMemberSubscribers?: string[];
    clientSubscribers?: string[];
    isOverdue?: boolean;
    overdueDate?: string | undefined;
    approvalDate?: string | undefined;
    inputRcvdDate?: string | undefined;
    firstCheckedDate?: Date | undefined;
    country?: string;
}

export class UpdateBooleanTaskDto implements IUpdateBooleanTaskDto {
    id?: string;
    title?: string;
    subTitle?: string;
    content?: string;
    sourceId?: string;
    displayDate?: Date;
    processId?: string;
    metaData?: string;
    value?: boolean | undefined;
    networkMemberId?: string;
    clientId?: string;
    status?: Status;
    adminDbAttachments?: string[];
    isOverdue?: boolean;
    overdueDate?: Date | undefined;
    approvalDate?: Date | undefined;
    inputRcvdDate?: Date | undefined;
    assignedTo?: AssignedTo;
    systemAttachments?: Attachment[];
    isNewTask?: boolean;

    constructor(data?: IUpdateBooleanTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.subTitle = _data["subTitle"];
            this.content = _data["content"];
            this.sourceId = _data["sourceId"];
            this.displayDate = _data["displayDate"] ? new Date(_data["displayDate"].toString()) : <any>undefined;
            this.processId = _data["processId"];
            this.metaData = _data["metaData"];
            this.value = _data["value"];
            this.networkMemberId = _data["networkMemberId"];
            this.clientId = _data["clientId"];
            this.status = _data["status"] ? Status.fromJS(_data["status"]) : <any>undefined;
            if (Array.isArray(_data["adminDbAttachments"])) {
                this.adminDbAttachments = [] as any;
                for (let item of _data["adminDbAttachments"])
                    this.adminDbAttachments!.push(item);
            }
            this.isOverdue = _data["isOverdue"];
            this.overdueDate = _data["overdueDate"] ? new Date(_data["overdueDate"].toString()) : <any>undefined;
            this.approvalDate = _data["approvalDate"] ? new Date(_data["approvalDate"].toString()) : <any>undefined;
            this.inputRcvdDate = _data["inputRcvdDate"] ? new Date(_data["inputRcvdDate"].toString()) : <any>undefined;
            this.assignedTo = _data["assignedTo"];
            if (Array.isArray(_data["systemAttachments"])) {
                this.systemAttachments = [] as any;
                for (let item of _data["systemAttachments"])
                    this.systemAttachments!.push(Attachment.fromJS(item));
            }
            this.isNewTask = _data["isNewTask"];
        }
    }

    static fromJS(data: any): UpdateBooleanTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBooleanTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["subTitle"] = this.subTitle;
        data["content"] = this.content;
        data["sourceId"] = this.sourceId;
        data["displayDate"] = this.displayDate ? this.displayDate.toISOString() : <any>undefined;
        data["processId"] = this.processId;
        data["metaData"] = this.metaData;
        data["value"] = this.value;
        data["networkMemberId"] = this.networkMemberId;
        data["clientId"] = this.clientId;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        if (Array.isArray(this.adminDbAttachments)) {
            data["adminDbAttachments"] = [];
            for (let item of this.adminDbAttachments)
                data["adminDbAttachments"].push(item);
        }
        data["isOverdue"] = this.isOverdue;
        data["overdueDate"] = this.overdueDate ? this.overdueDate.toISOString() : <any>undefined;
        data["approvalDate"] = this.approvalDate ? this.approvalDate.toISOString() : <any>undefined;
        data["inputRcvdDate"] = this.inputRcvdDate ? this.inputRcvdDate.toISOString() : <any>undefined;
        data["assignedTo"] = this.assignedTo;
        if (Array.isArray(this.systemAttachments)) {
            data["systemAttachments"] = [];
            for (let item of this.systemAttachments)
                data["systemAttachments"].push(item.toJSON());
        }
        data["isNewTask"] = this.isNewTask;
        return data;
    }
}

export interface IUpdateBooleanTaskDto {
    id?: string;
    title?: string;
    subTitle?: string;
    content?: string;
    sourceId?: string;
    displayDate?: Date;
    processId?: string;
    metaData?: string;
    value?: boolean | undefined;
    networkMemberId?: string;
    clientId?: string;
    status?: Status;
    adminDbAttachments?: string[];
    isOverdue?: boolean;
    overdueDate?: Date | undefined;
    approvalDate?: Date | undefined;
    inputRcvdDate?: Date | undefined;
    assignedTo?: AssignedTo;
    systemAttachments?: Attachment[];
    isNewTask?: boolean;
}

export class TaskSubscribersDto implements ITaskSubscribersDto {
    id?: string;
    processId?: string;
    insuropeSubscribers?: TaskUserSusbscriptionDto[];
    networkMemberSubscribers?: TaskUserSusbscriptionDto[];
    clientSubscribers?: TaskUserSusbscriptionDto[];

    constructor(data?: ITaskSubscribersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.processId = _data["processId"];
            if (Array.isArray(_data["insuropeSubscribers"])) {
                this.insuropeSubscribers = [] as any;
                for (let item of _data["insuropeSubscribers"])
                    this.insuropeSubscribers!.push(TaskUserSusbscriptionDto.fromJS(item));
            }
            if (Array.isArray(_data["networkMemberSubscribers"])) {
                this.networkMemberSubscribers = [] as any;
                for (let item of _data["networkMemberSubscribers"])
                    this.networkMemberSubscribers!.push(TaskUserSusbscriptionDto.fromJS(item));
            }
            if (Array.isArray(_data["clientSubscribers"])) {
                this.clientSubscribers = [] as any;
                for (let item of _data["clientSubscribers"])
                    this.clientSubscribers!.push(TaskUserSusbscriptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskSubscribersDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskSubscribersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processId"] = this.processId;
        if (Array.isArray(this.insuropeSubscribers)) {
            data["insuropeSubscribers"] = [];
            for (let item of this.insuropeSubscribers)
                data["insuropeSubscribers"].push(item.toJSON());
        }
        if (Array.isArray(this.networkMemberSubscribers)) {
            data["networkMemberSubscribers"] = [];
            for (let item of this.networkMemberSubscribers)
                data["networkMemberSubscribers"].push(item.toJSON());
        }
        if (Array.isArray(this.clientSubscribers)) {
            data["clientSubscribers"] = [];
            for (let item of this.clientSubscribers)
                data["clientSubscribers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITaskSubscribersDto {
    id?: string;
    processId?: string;
    insuropeSubscribers?: TaskUserSusbscriptionDto[];
    networkMemberSubscribers?: TaskUserSusbscriptionDto[];
    clientSubscribers?: TaskUserSusbscriptionDto[];
}

export class TaskUserSusbscriptionDto implements ITaskUserSusbscriptionDto {
    id?: string;
    sourceId?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    preferredEmail?: string;
    networkMemberIds?: string[];
    clientId?: string;
    active?: boolean;
    isFinancial?: boolean | undefined;
    isManuallyAdded?: boolean;
    isDeleted?: boolean;
    removedFromDiscussion?: boolean;

    constructor(data?: ITaskUserSusbscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceId = _data["sourceId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.preferredEmail = _data["preferredEmail"];
            if (Array.isArray(_data["networkMemberIds"])) {
                this.networkMemberIds = [] as any;
                for (let item of _data["networkMemberIds"])
                    this.networkMemberIds!.push(item);
            }
            this.clientId = _data["clientId"];
            this.active = _data["active"];
            this.isFinancial = _data["isFinancial"];
            this.isManuallyAdded = _data["isManuallyAdded"];
            this.isDeleted = _data["isDeleted"];
            this.removedFromDiscussion = _data["removedFromDiscussion"];
        }
    }

    static fromJS(data: any): TaskUserSusbscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskUserSusbscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceId"] = this.sourceId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["preferredEmail"] = this.preferredEmail;
        if (Array.isArray(this.networkMemberIds)) {
            data["networkMemberIds"] = [];
            for (let item of this.networkMemberIds)
                data["networkMemberIds"].push(item);
        }
        data["clientId"] = this.clientId;
        data["active"] = this.active;
        data["isFinancial"] = this.isFinancial;
        data["isManuallyAdded"] = this.isManuallyAdded;
        data["isDeleted"] = this.isDeleted;
        data["removedFromDiscussion"] = this.removedFromDiscussion;
        return data;
    }
}

export interface ITaskUserSusbscriptionDto {
    id?: string;
    sourceId?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    preferredEmail?: string;
    networkMemberIds?: string[];
    clientId?: string;
    active?: boolean;
    isFinancial?: boolean | undefined;
    isManuallyAdded?: boolean;
    isDeleted?: boolean;
    removedFromDiscussion?: boolean;
}

export class CommentDto implements ICommentDto {
    id?: string;
    userId?: string;
    firstName?: string;
    lastName?: string;
    content?: string;
    networkMemberId?: string;
    messageSent?: Date;
    isDeleted?: boolean;
    isEdited?: boolean;
    isHtmlText?: boolean;
    commentType?: CommentType;
    attachments?: Attachment[];
    tags?: CommentTagDto[];
    createdByUserRolls?: string[];

    constructor(data?: ICommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.content = _data["content"];
            this.networkMemberId = _data["networkMemberId"];
            this.messageSent = _data["messageSent"] ? new Date(_data["messageSent"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.isEdited = _data["isEdited"];
            this.isHtmlText = _data["isHtmlText"];
            this.commentType = _data["commentType"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(Attachment.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(CommentTagDto.fromJS(item));
            }
            if (Array.isArray(_data["createdByUserRolls"])) {
                this.createdByUserRolls = [] as any;
                for (let item of _data["createdByUserRolls"])
                    this.createdByUserRolls!.push(item);
            }
        }
    }

    static fromJS(data: any): CommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["content"] = this.content;
        data["networkMemberId"] = this.networkMemberId;
        data["messageSent"] = this.messageSent ? this.messageSent.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["isEdited"] = this.isEdited;
        data["isHtmlText"] = this.isHtmlText;
        data["commentType"] = this.commentType;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        if (Array.isArray(this.createdByUserRolls)) {
            data["createdByUserRolls"] = [];
            for (let item of this.createdByUserRolls)
                data["createdByUserRolls"].push(item);
        }
        return data;
    }
}

export interface ICommentDto {
    id?: string;
    userId?: string;
    firstName?: string;
    lastName?: string;
    content?: string;
    networkMemberId?: string;
    messageSent?: Date;
    isDeleted?: boolean;
    isEdited?: boolean;
    isHtmlText?: boolean;
    commentType?: CommentType;
    attachments?: Attachment[];
    tags?: CommentTagDto[];
    createdByUserRolls?: string[];
}

export enum CommentType {
    Comment = 0,
    Reply = 1,
    Edited = 2,
    Automated = 3,
    ApprovalLetter = 4,
    ExternalComment = 5,
}

export class CommentTagDto extends AuditableEntity implements ICommentTagDto {
    id?: string;
    tagName?: string;
    isDeletable?: boolean;
    createdByUserRoles?: string[];

    constructor(data?: ICommentTagDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.tagName = _data["tagName"];
            this.isDeletable = _data["isDeletable"];
            if (Array.isArray(_data["createdByUserRoles"])) {
                this.createdByUserRoles = [] as any;
                for (let item of _data["createdByUserRoles"])
                    this.createdByUserRoles!.push(item);
            }
        }
    }

    static fromJS(data: any): CommentTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommentTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tagName"] = this.tagName;
        data["isDeletable"] = this.isDeletable;
        if (Array.isArray(this.createdByUserRoles)) {
            data["createdByUserRoles"] = [];
            for (let item of this.createdByUserRoles)
                data["createdByUserRoles"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICommentTagDto extends IAuditableEntity {
    id?: string;
    tagName?: string;
    isDeletable?: boolean;
    createdByUserRoles?: string[];
}

export class DiscussionDto implements IDiscussionDto {
    id?: string;
    lastExported?: Date | undefined;
    taskId?: string;
    comments?: Comment[];
    systemAttachments?: Attachment[];

    constructor(data?: IDiscussionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastExported = _data["lastExported"] ? new Date(_data["lastExported"].toString()) : <any>undefined;
            this.taskId = _data["taskId"];
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(Comment.fromJS(item));
            }
            if (Array.isArray(_data["systemAttachments"])) {
                this.systemAttachments = [] as any;
                for (let item of _data["systemAttachments"])
                    this.systemAttachments!.push(Attachment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DiscussionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiscussionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastExported"] = this.lastExported ? this.lastExported.toISOString() : <any>undefined;
        data["taskId"] = this.taskId;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        if (Array.isArray(this.systemAttachments)) {
            data["systemAttachments"] = [];
            for (let item of this.systemAttachments)
                data["systemAttachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDiscussionDto {
    id?: string;
    lastExported?: Date | undefined;
    taskId?: string;
    comments?: Comment[];
    systemAttachments?: Attachment[];
}

export class Comment extends AuditableEntity implements IComment {
    id?: string;
    userId?: string;
    firstName?: string;
    lastName?: string;
    content?: string;
    networkMemberId?: string;
    messageSent?: Date;
    isDeleted?: boolean;
    isEdited?: boolean;
    isHtmlText?: boolean;
    commentType?: CommentType;
    attachments?: Attachment[];
    tags?: CommentTag[];
    createdByUserRolls?: string[];

    constructor(data?: IComment) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.content = _data["content"];
            this.networkMemberId = _data["networkMemberId"];
            this.messageSent = _data["messageSent"] ? new Date(_data["messageSent"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.isEdited = _data["isEdited"];
            this.isHtmlText = _data["isHtmlText"];
            this.commentType = _data["commentType"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(Attachment.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(CommentTag.fromJS(item));
            }
            if (Array.isArray(_data["createdByUserRolls"])) {
                this.createdByUserRolls = [] as any;
                for (let item of _data["createdByUserRolls"])
                    this.createdByUserRolls!.push(item);
            }
        }
    }

    static fromJS(data: any): Comment {
        data = typeof data === 'object' ? data : {};
        let result = new Comment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["content"] = this.content;
        data["networkMemberId"] = this.networkMemberId;
        data["messageSent"] = this.messageSent ? this.messageSent.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["isEdited"] = this.isEdited;
        data["isHtmlText"] = this.isHtmlText;
        data["commentType"] = this.commentType;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        if (Array.isArray(this.createdByUserRolls)) {
            data["createdByUserRolls"] = [];
            for (let item of this.createdByUserRolls)
                data["createdByUserRolls"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IComment extends IAuditableEntity {
    id?: string;
    userId?: string;
    firstName?: string;
    lastName?: string;
    content?: string;
    networkMemberId?: string;
    messageSent?: Date;
    isDeleted?: boolean;
    isEdited?: boolean;
    isHtmlText?: boolean;
    commentType?: CommentType;
    attachments?: Attachment[];
    tags?: CommentTag[];
    createdByUserRolls?: string[];
}

export class CommentTag extends AuditableEntity implements ICommentTag {
    id?: string;
    tagName?: string;
    isDeletable?: boolean;
    createdByUserRoles?: string[];

    constructor(data?: ICommentTag) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.tagName = _data["tagName"];
            this.isDeletable = _data["isDeletable"];
            if (Array.isArray(_data["createdByUserRoles"])) {
                this.createdByUserRoles = [] as any;
                for (let item of _data["createdByUserRoles"])
                    this.createdByUserRoles!.push(item);
            }
        }
    }

    static fromJS(data: any): CommentTag {
        data = typeof data === 'object' ? data : {};
        let result = new CommentTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tagName"] = this.tagName;
        data["isDeletable"] = this.isDeletable;
        if (Array.isArray(this.createdByUserRoles)) {
            data["createdByUserRoles"] = [];
            for (let item of this.createdByUserRoles)
                data["createdByUserRoles"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICommentTag extends IAuditableEntity {
    id?: string;
    tagName?: string;
    isDeletable?: boolean;
    createdByUserRoles?: string[];
}

export class AttachmentDTO implements IAttachmentDTO {
    id?: string;
    name?: string;
    path?: string;
    fileType?: string;
    commentId?: string;
    fileDate?: Date;

    constructor(data?: IAttachmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.path = _data["path"];
            this.fileType = _data["fileType"];
            this.commentId = _data["commentId"];
            this.fileDate = _data["fileDate"] ? new Date(_data["fileDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AttachmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["path"] = this.path;
        data["fileType"] = this.fileType;
        data["commentId"] = this.commentId;
        data["fileDate"] = this.fileDate ? this.fileDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAttachmentDTO {
    id?: string;
    name?: string;
    path?: string;
    fileType?: string;
    commentId?: string;
    fileDate?: Date;
}

export class AddExternalCommentsCommand implements IAddExternalCommentsCommand {
    externalComments?: ExternalComment[];

    constructor(data?: IAddExternalCommentsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["externalComments"])) {
                this.externalComments = [] as any;
                for (let item of _data["externalComments"])
                    this.externalComments!.push(ExternalComment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddExternalCommentsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddExternalCommentsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.externalComments)) {
            data["externalComments"] = [];
            for (let item of this.externalComments)
                data["externalComments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddExternalCommentsCommand {
    externalComments?: ExternalComment[];
}

export class ExternalComment implements IExternalComment {
    sourceId?: string;
    content?: string;
    processId?: ProcessIds;
    clientName?: string;
    networkMemberName?: string;
    periodEndYear?: string;
    country?: string;
    userEmailAddress?: string;
    isServiceUser?: boolean;
    isHtmlText?: boolean;
    notificationFrequency?: NotificationFrequency;
    notificationType?: NotificationType;
    attachments?: UploadFileDto[];
    tags?: string[];

    constructor(data?: IExternalComment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.content = _data["content"];
            this.processId = _data["processId"];
            this.clientName = _data["clientName"];
            this.networkMemberName = _data["networkMemberName"];
            this.periodEndYear = _data["periodEndYear"];
            this.country = _data["country"];
            this.userEmailAddress = _data["userEmailAddress"];
            this.isServiceUser = _data["isServiceUser"];
            this.isHtmlText = _data["isHtmlText"];
            this.notificationFrequency = _data["notificationFrequency"];
            this.notificationType = _data["notificationType"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(UploadFileDto.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): ExternalComment {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalComment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["content"] = this.content;
        data["processId"] = this.processId;
        data["clientName"] = this.clientName;
        data["networkMemberName"] = this.networkMemberName;
        data["periodEndYear"] = this.periodEndYear;
        data["country"] = this.country;
        data["userEmailAddress"] = this.userEmailAddress;
        data["isServiceUser"] = this.isServiceUser;
        data["isHtmlText"] = this.isHtmlText;
        data["notificationFrequency"] = this.notificationFrequency;
        data["notificationType"] = this.notificationType;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface IExternalComment {
    sourceId?: string;
    content?: string;
    processId?: ProcessIds;
    clientName?: string;
    networkMemberName?: string;
    periodEndYear?: string;
    country?: string;
    userEmailAddress?: string;
    isServiceUser?: boolean;
    isHtmlText?: boolean;
    notificationFrequency?: NotificationFrequency;
    notificationType?: NotificationType;
    attachments?: UploadFileDto[];
    tags?: string[];
}

export enum ProcessIds {
    PoolingPermissions = 0,
    IllustrationInputs = 1,
    AccountInputs = 2,
    Approvals = 3,
    Payments = 4,
    ServiceFees = 5,
    AnnualReport = 6,
    Illustrations = 7,
    MultipoolApprovals = 8,
    MultipoolPayments = 9,
    IllustrationRequestInput = 10,
}

export class ContactDto implements IContactDto {
    id?: string;
    name?: string;
    email?: string;
    workPhone?: string;
    isPrimary?: boolean;
    account?: AccountDto;

    constructor(data?: IContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.workPhone = _data["workPhone"];
            this.isPrimary = _data["isPrimary"];
            this.account = _data["account"] ? AccountDto.fromJS(_data["account"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["workPhone"] = this.workPhone;
        data["isPrimary"] = this.isPrimary;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        return data;
    }
}

export interface IContactDto {
    id?: string;
    name?: string;
    email?: string;
    workPhone?: string;
    isPrimary?: boolean;
    account?: AccountDto;
}

export class CountyDto implements ICountyDto {
    countyId?: string;
    name?: string;

    constructor(data?: ICountyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countyId = _data["countyId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CountyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countyId"] = this.countyId;
        data["name"] = this.name;
        return data;
    }
}

export interface ICountyDto {
    countyId?: string;
    name?: string;
}

export class PaginatedListOfCrmAttachmentDto implements IPaginatedListOfCrmAttachmentDto {
    items?: CrmAttachmentDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfCrmAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CrmAttachmentDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfCrmAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfCrmAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfCrmAttachmentDto {
    items?: CrmAttachmentDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class CrmAttachmentDto implements ICrmAttachmentDto {
    id?: string;
    fileName?: string;
    modifyDate?: Date;
    attachDate?: Date;
    fileSize?: number;
    description?: string;
    createUser?: UserInfoDto;
    details?: AttachmentDetailsDto;

    constructor(data?: ICrmAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.modifyDate = _data["modifyDate"] ? new Date(_data["modifyDate"].toString()) : <any>undefined;
            this.attachDate = _data["attachDate"] ? new Date(_data["attachDate"].toString()) : <any>undefined;
            this.fileSize = _data["fileSize"];
            this.description = _data["description"];
            this.createUser = _data["createUser"] ? UserInfoDto.fromJS(_data["createUser"]) : <any>undefined;
            this.details = _data["details"] ? AttachmentDetailsDto.fromJS(_data["details"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CrmAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CrmAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["modifyDate"] = this.modifyDate ? this.modifyDate.toISOString() : <any>undefined;
        data["attachDate"] = this.attachDate ? this.attachDate.toISOString() : <any>undefined;
        data["fileSize"] = this.fileSize;
        data["description"] = this.description;
        data["createUser"] = this.createUser ? this.createUser.toJSON() : <any>undefined;
        data["details"] = this.details ? this.details.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICrmAttachmentDto {
    id?: string;
    fileName?: string;
    modifyDate?: Date;
    attachDate?: Date;
    fileSize?: number;
    description?: string;
    createUser?: UserInfoDto;
    details?: AttachmentDetailsDto;
}

export class AttachmentDetailsDto implements IAttachmentDetailsDto {
    attachmentsecurity?: string;
    importantFile?: string;
    subType?: string;

    constructor(data?: IAttachmentDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachmentsecurity = _data["attachmentsecurity"];
            this.importantFile = _data["importantFile"];
            this.subType = _data["subType"];
        }
    }

    static fromJS(data: any): AttachmentDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachmentsecurity"] = this.attachmentsecurity;
        data["importantFile"] = this.importantFile;
        data["subType"] = this.subType;
        return data;
    }
}

export interface IAttachmentDetailsDto {
    attachmentsecurity?: string;
    importantFile?: string;
    subType?: string;
}

export class FaqCategoryDto implements IFaqCategoryDto {
    id?: string;
    name?: string;
    sortOrder?: number;
    questions?: QuestionDto[];

    constructor(data?: IFaqCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(QuestionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FaqCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new FaqCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFaqCategoryDto {
    id?: string;
    name?: string;
    sortOrder?: number;
    questions?: QuestionDto[];
}

export class QuestionDto implements IQuestionDto {
    id?: string;
    title?: string;
    answer?: string;

    constructor(data?: IQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.answer = _data["answer"];
        }
    }

    static fromJS(data: any): QuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["answer"] = this.answer;
        return data;
    }
}

export interface IQuestionDto {
    id?: string;
    title?: string;
    answer?: string;
}

export class UpdateFaqCommand implements IUpdateFaqCommand {
    id?: string;
    name?: string;
    sortOrder?: number;
    questions?: Question[];

    constructor(data?: IUpdateFaqCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(Question.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateFaqCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFaqCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateFaqCommand {
    id?: string;
    name?: string;
    sortOrder?: number;
    questions?: Question[];
}

export class Question extends AuditableEntity implements IQuestion {
    id?: string;
    title?: string;
    answer?: string;

    constructor(data?: IQuestion) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.answer = _data["answer"];
        }
    }

    static fromJS(data: any): Question {
        data = typeof data === 'object' ? data : {};
        let result = new Question();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["answer"] = this.answer;
        super.toJSON(data);
        return data;
    }
}

export interface IQuestion extends IAuditableEntity {
    id?: string;
    title?: string;
    answer?: string;
}

export class FileUploadTaskDto extends BaseTaskDto implements IFileUploadTaskDto {
    country?: string;
    attachments?: Attachment[];

    constructor(data?: IFileUploadTaskDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.country = _data["country"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(Attachment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileUploadTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFileUploadTaskDto extends IBaseTaskDto {
    country?: string;
    attachments?: Attachment[];
}

export class UpsertFileUploadTaskCommand implements IUpsertFileUploadTaskCommand {
    sourceId?: string;
    title?: string;
    subTitle?: string;
    content?: string;
    displayDate?: Date | undefined;
    metaData?: string;
    processId?: string;
    value?: boolean | undefined;
    networkMemberId?: string;
    clientId?: string;
    country?: string;
    status?: Status;
    streamAttachments?: Stream[];
    adminDbAttachments?: string[];
    insuropeSubscribers?: string[];
    networkMemberSubscribers?: string[];
    clientSubscribers?: string[];
    isOverdue?: boolean;
    overdueDate?: string | undefined;
    maxApprovalCheckedDate?: Date | undefined;
    actionPerform?: ActionPerform | undefined;
    actionPerformDate?: Date | undefined;

    constructor(data?: IUpsertFileUploadTaskCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.title = _data["title"];
            this.subTitle = _data["subTitle"];
            this.content = _data["content"];
            this.displayDate = _data["displayDate"] ? new Date(_data["displayDate"].toString()) : <any>undefined;
            this.metaData = _data["metaData"];
            this.processId = _data["processId"];
            this.value = _data["value"];
            this.networkMemberId = _data["networkMemberId"];
            this.clientId = _data["clientId"];
            this.country = _data["country"];
            this.status = _data["status"] ? Status.fromJS(_data["status"]) : <any>undefined;
            if (Array.isArray(_data["streamAttachments"])) {
                this.streamAttachments = [] as any;
                for (let item of _data["streamAttachments"])
                    this.streamAttachments!.push(Stream.fromJS(item));
            }
            if (Array.isArray(_data["adminDbAttachments"])) {
                this.adminDbAttachments = [] as any;
                for (let item of _data["adminDbAttachments"])
                    this.adminDbAttachments!.push(item);
            }
            if (Array.isArray(_data["insuropeSubscribers"])) {
                this.insuropeSubscribers = [] as any;
                for (let item of _data["insuropeSubscribers"])
                    this.insuropeSubscribers!.push(item);
            }
            if (Array.isArray(_data["networkMemberSubscribers"])) {
                this.networkMemberSubscribers = [] as any;
                for (let item of _data["networkMemberSubscribers"])
                    this.networkMemberSubscribers!.push(item);
            }
            if (Array.isArray(_data["clientSubscribers"])) {
                this.clientSubscribers = [] as any;
                for (let item of _data["clientSubscribers"])
                    this.clientSubscribers!.push(item);
            }
            this.isOverdue = _data["isOverdue"];
            this.overdueDate = _data["overdueDate"];
            this.maxApprovalCheckedDate = _data["maxApprovalCheckedDate"] ? new Date(_data["maxApprovalCheckedDate"].toString()) : <any>undefined;
            this.actionPerform = _data["actionPerform"];
            this.actionPerformDate = _data["actionPerformDate"] ? new Date(_data["actionPerformDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpsertFileUploadTaskCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertFileUploadTaskCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["title"] = this.title;
        data["subTitle"] = this.subTitle;
        data["content"] = this.content;
        data["displayDate"] = this.displayDate ? this.displayDate.toISOString() : <any>undefined;
        data["metaData"] = this.metaData;
        data["processId"] = this.processId;
        data["value"] = this.value;
        data["networkMemberId"] = this.networkMemberId;
        data["clientId"] = this.clientId;
        data["country"] = this.country;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        if (Array.isArray(this.streamAttachments)) {
            data["streamAttachments"] = [];
            for (let item of this.streamAttachments)
                data["streamAttachments"].push(item.toJSON());
        }
        if (Array.isArray(this.adminDbAttachments)) {
            data["adminDbAttachments"] = [];
            for (let item of this.adminDbAttachments)
                data["adminDbAttachments"].push(item);
        }
        if (Array.isArray(this.insuropeSubscribers)) {
            data["insuropeSubscribers"] = [];
            for (let item of this.insuropeSubscribers)
                data["insuropeSubscribers"].push(item);
        }
        if (Array.isArray(this.networkMemberSubscribers)) {
            data["networkMemberSubscribers"] = [];
            for (let item of this.networkMemberSubscribers)
                data["networkMemberSubscribers"].push(item);
        }
        if (Array.isArray(this.clientSubscribers)) {
            data["clientSubscribers"] = [];
            for (let item of this.clientSubscribers)
                data["clientSubscribers"].push(item);
        }
        data["isOverdue"] = this.isOverdue;
        data["overdueDate"] = this.overdueDate;
        data["maxApprovalCheckedDate"] = this.maxApprovalCheckedDate ? this.maxApprovalCheckedDate.toISOString() : <any>undefined;
        data["actionPerform"] = this.actionPerform;
        data["actionPerformDate"] = this.actionPerformDate ? this.actionPerformDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpsertFileUploadTaskCommand {
    sourceId?: string;
    title?: string;
    subTitle?: string;
    content?: string;
    displayDate?: Date | undefined;
    metaData?: string;
    processId?: string;
    value?: boolean | undefined;
    networkMemberId?: string;
    clientId?: string;
    country?: string;
    status?: Status;
    streamAttachments?: Stream[];
    adminDbAttachments?: string[];
    insuropeSubscribers?: string[];
    networkMemberSubscribers?: string[];
    clientSubscribers?: string[];
    isOverdue?: boolean;
    overdueDate?: string | undefined;
    maxApprovalCheckedDate?: Date | undefined;
    actionPerform?: ActionPerform | undefined;
    actionPerformDate?: Date | undefined;
}

export class GeneralTaskDto extends BaseTaskDto implements IGeneralTaskDto {
    payTo?: PayToEnum;
    payStartedDate?: Date | undefined;
    attachments?: Attachment[];

    constructor(data?: IGeneralTaskDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.payTo = _data["payTo"];
            this.payStartedDate = _data["payStartedDate"] ? new Date(_data["payStartedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(Attachment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GeneralTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payTo"] = this.payTo;
        data["payStartedDate"] = this.payStartedDate ? this.payStartedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGeneralTaskDto extends IBaseTaskDto {
    payTo?: PayToEnum;
    payStartedDate?: Date | undefined;
    attachments?: Attachment[];
}

export class UpsertGeneralTaskCommand implements IUpsertGeneralTaskCommand {
    sourceId?: string;
    title?: string;
    subTitle?: string;
    content?: string;
    displayDate?: Date;
    processId?: string;
    networkMemberId?: string;
    clientId?: string;
    metaData?: string;
    status?: Status;
    taskId?: string | undefined;
    country?: string | undefined;
    streamAttachments?: Stream[];
    adminDbAttachments?: string[];
    insuropeSubscribers?: string[];
    networkMemberSubscribers?: string[];
    clientSubscribers?: string[];
    overdueDate?: string | undefined;
    payTo?: PayToEnum;
    payStartedDate?: Date | undefined;
    requestSource?: RequestSource;
    actionPerform?: ActionPerform | undefined;
    actionPerformDate?: Date | undefined;

    constructor(data?: IUpsertGeneralTaskCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.title = _data["title"];
            this.subTitle = _data["subTitle"];
            this.content = _data["content"];
            this.displayDate = _data["displayDate"] ? new Date(_data["displayDate"].toString()) : <any>undefined;
            this.processId = _data["processId"];
            this.networkMemberId = _data["networkMemberId"];
            this.clientId = _data["clientId"];
            this.metaData = _data["metaData"];
            this.status = _data["status"] ? Status.fromJS(_data["status"]) : <any>undefined;
            this.taskId = _data["taskId"];
            this.country = _data["country"];
            if (Array.isArray(_data["streamAttachments"])) {
                this.streamAttachments = [] as any;
                for (let item of _data["streamAttachments"])
                    this.streamAttachments!.push(Stream.fromJS(item));
            }
            if (Array.isArray(_data["adminDbAttachments"])) {
                this.adminDbAttachments = [] as any;
                for (let item of _data["adminDbAttachments"])
                    this.adminDbAttachments!.push(item);
            }
            if (Array.isArray(_data["insuropeSubscribers"])) {
                this.insuropeSubscribers = [] as any;
                for (let item of _data["insuropeSubscribers"])
                    this.insuropeSubscribers!.push(item);
            }
            if (Array.isArray(_data["networkMemberSubscribers"])) {
                this.networkMemberSubscribers = [] as any;
                for (let item of _data["networkMemberSubscribers"])
                    this.networkMemberSubscribers!.push(item);
            }
            if (Array.isArray(_data["clientSubscribers"])) {
                this.clientSubscribers = [] as any;
                for (let item of _data["clientSubscribers"])
                    this.clientSubscribers!.push(item);
            }
            this.overdueDate = _data["overdueDate"];
            this.payTo = _data["payTo"];
            this.payStartedDate = _data["payStartedDate"] ? new Date(_data["payStartedDate"].toString()) : <any>undefined;
            this.requestSource = _data["requestSource"];
            this.actionPerform = _data["actionPerform"];
            this.actionPerformDate = _data["actionPerformDate"] ? new Date(_data["actionPerformDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpsertGeneralTaskCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertGeneralTaskCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["title"] = this.title;
        data["subTitle"] = this.subTitle;
        data["content"] = this.content;
        data["displayDate"] = this.displayDate ? this.displayDate.toISOString() : <any>undefined;
        data["processId"] = this.processId;
        data["networkMemberId"] = this.networkMemberId;
        data["clientId"] = this.clientId;
        data["metaData"] = this.metaData;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["taskId"] = this.taskId;
        data["country"] = this.country;
        if (Array.isArray(this.streamAttachments)) {
            data["streamAttachments"] = [];
            for (let item of this.streamAttachments)
                data["streamAttachments"].push(item.toJSON());
        }
        if (Array.isArray(this.adminDbAttachments)) {
            data["adminDbAttachments"] = [];
            for (let item of this.adminDbAttachments)
                data["adminDbAttachments"].push(item);
        }
        if (Array.isArray(this.insuropeSubscribers)) {
            data["insuropeSubscribers"] = [];
            for (let item of this.insuropeSubscribers)
                data["insuropeSubscribers"].push(item);
        }
        if (Array.isArray(this.networkMemberSubscribers)) {
            data["networkMemberSubscribers"] = [];
            for (let item of this.networkMemberSubscribers)
                data["networkMemberSubscribers"].push(item);
        }
        if (Array.isArray(this.clientSubscribers)) {
            data["clientSubscribers"] = [];
            for (let item of this.clientSubscribers)
                data["clientSubscribers"].push(item);
        }
        data["overdueDate"] = this.overdueDate;
        data["payTo"] = this.payTo;
        data["payStartedDate"] = this.payStartedDate ? this.payStartedDate.toISOString() : <any>undefined;
        data["requestSource"] = this.requestSource;
        data["actionPerform"] = this.actionPerform;
        data["actionPerformDate"] = this.actionPerformDate ? this.actionPerformDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpsertGeneralTaskCommand {
    sourceId?: string;
    title?: string;
    subTitle?: string;
    content?: string;
    displayDate?: Date;
    processId?: string;
    networkMemberId?: string;
    clientId?: string;
    metaData?: string;
    status?: Status;
    taskId?: string | undefined;
    country?: string | undefined;
    streamAttachments?: Stream[];
    adminDbAttachments?: string[];
    insuropeSubscribers?: string[];
    networkMemberSubscribers?: string[];
    clientSubscribers?: string[];
    overdueDate?: string | undefined;
    payTo?: PayToEnum;
    payStartedDate?: Date | undefined;
    requestSource?: RequestSource;
    actionPerform?: ActionPerform | undefined;
    actionPerformDate?: Date | undefined;
}

export enum RequestSource {
    Hangfire = 0,
    AzureMessagingService = 1,
}

export class UpdateHangfireJobCommand implements IUpdateHangfireJobCommand {
    id?: string;
    processName?: string;
    jobName?: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IUpdateHangfireJobCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.processName = _data["processName"];
            this.jobName = _data["jobName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): UpdateHangfireJobCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHangfireJobCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processName"] = this.processName;
        data["jobName"] = this.jobName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IUpdateHangfireJobCommand {
    id?: string;
    processName?: string;
    jobName?: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    errorMessage?: string | undefined;
}

export class JobExecutionInfoDto implements IJobExecutionInfoDto {
    id?: string;
    processName?: string;
    jobName?: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    status?: string | undefined;

    constructor(data?: IJobExecutionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.processName = _data["processName"];
            this.jobName = _data["jobName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): JobExecutionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobExecutionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processName"] = this.processName;
        data["jobName"] = this.jobName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface IJobExecutionInfoDto {
    id?: string;
    processName?: string;
    jobName?: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    status?: string | undefined;
}

export class IllustrationRequestDto implements IIllustrationRequestDto {
    id?: string;
    clientName?: string;
    clientId?: string;
    illustrationStage?: IllustrationStageDto;
    assignedToId?: string | undefined;
    assignedToEmail?: string;
    insuropeTypeOfBusiness?: boolean | undefined;
    commonCurrencyId?: string;
    memberTypeOfBusiness?: string;
    brokerName?: string;
    renewal?: boolean | undefined;
    statusComment?: string;
    networkMemberComments?: string;
    insuropeAdditionalComments?: string;
    wordMPPPath?: string;
    illustrationRevisions?: IllustrationRevisionDto[];
    illustrationType?: IllustrationTypeDto;
    salesRepresentative?: GraphApiUserDto;
    supportRepresentative?: GraphApiUserDto;
    networkMember?: AccountDto;
    countries?: CountryDto[];
    networkMemberSubscribers?: string[];

    constructor(data?: IIllustrationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientName = _data["clientName"];
            this.clientId = _data["clientId"];
            this.illustrationStage = _data["illustrationStage"] ? IllustrationStageDto.fromJS(_data["illustrationStage"]) : <any>undefined;
            this.assignedToId = _data["assignedToId"];
            this.assignedToEmail = _data["assignedToEmail"];
            this.insuropeTypeOfBusiness = _data["insuropeTypeOfBusiness"];
            this.commonCurrencyId = _data["commonCurrencyId"];
            this.memberTypeOfBusiness = _data["memberTypeOfBusiness"];
            this.brokerName = _data["brokerName"];
            this.renewal = _data["renewal"];
            this.statusComment = _data["statusComment"];
            this.networkMemberComments = _data["networkMemberComments"];
            this.insuropeAdditionalComments = _data["insuropeAdditionalComments"];
            this.wordMPPPath = _data["wordMPPPath"];
            if (Array.isArray(_data["illustrationRevisions"])) {
                this.illustrationRevisions = [] as any;
                for (let item of _data["illustrationRevisions"])
                    this.illustrationRevisions!.push(IllustrationRevisionDto.fromJS(item));
            }
            this.illustrationType = _data["illustrationType"] ? IllustrationTypeDto.fromJS(_data["illustrationType"]) : <any>undefined;
            this.salesRepresentative = _data["salesRepresentative"] ? GraphApiUserDto.fromJS(_data["salesRepresentative"]) : <any>undefined;
            this.supportRepresentative = _data["supportRepresentative"] ? GraphApiUserDto.fromJS(_data["supportRepresentative"]) : <any>undefined;
            this.networkMember = _data["networkMember"] ? AccountDto.fromJS(_data["networkMember"]) : <any>undefined;
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(CountryDto.fromJS(item));
            }
            if (Array.isArray(_data["networkMemberSubscribers"])) {
                this.networkMemberSubscribers = [] as any;
                for (let item of _data["networkMemberSubscribers"])
                    this.networkMemberSubscribers!.push(item);
            }
        }
    }

    static fromJS(data: any): IllustrationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new IllustrationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientName"] = this.clientName;
        data["clientId"] = this.clientId;
        data["illustrationStage"] = this.illustrationStage ? this.illustrationStage.toJSON() : <any>undefined;
        data["assignedToId"] = this.assignedToId;
        data["assignedToEmail"] = this.assignedToEmail;
        data["insuropeTypeOfBusiness"] = this.insuropeTypeOfBusiness;
        data["commonCurrencyId"] = this.commonCurrencyId;
        data["memberTypeOfBusiness"] = this.memberTypeOfBusiness;
        data["brokerName"] = this.brokerName;
        data["renewal"] = this.renewal;
        data["statusComment"] = this.statusComment;
        data["networkMemberComments"] = this.networkMemberComments;
        data["insuropeAdditionalComments"] = this.insuropeAdditionalComments;
        data["wordMPPPath"] = this.wordMPPPath;
        if (Array.isArray(this.illustrationRevisions)) {
            data["illustrationRevisions"] = [];
            for (let item of this.illustrationRevisions)
                data["illustrationRevisions"].push(item.toJSON());
        }
        data["illustrationType"] = this.illustrationType ? this.illustrationType.toJSON() : <any>undefined;
        data["salesRepresentative"] = this.salesRepresentative ? this.salesRepresentative.toJSON() : <any>undefined;
        data["supportRepresentative"] = this.supportRepresentative ? this.supportRepresentative.toJSON() : <any>undefined;
        data["networkMember"] = this.networkMember ? this.networkMember.toJSON() : <any>undefined;
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        if (Array.isArray(this.networkMemberSubscribers)) {
            data["networkMemberSubscribers"] = [];
            for (let item of this.networkMemberSubscribers)
                data["networkMemberSubscribers"].push(item);
        }
        return data;
    }
}

export interface IIllustrationRequestDto {
    id?: string;
    clientName?: string;
    clientId?: string;
    illustrationStage?: IllustrationStageDto;
    assignedToId?: string | undefined;
    assignedToEmail?: string;
    insuropeTypeOfBusiness?: boolean | undefined;
    commonCurrencyId?: string;
    memberTypeOfBusiness?: string;
    brokerName?: string;
    renewal?: boolean | undefined;
    statusComment?: string;
    networkMemberComments?: string;
    insuropeAdditionalComments?: string;
    wordMPPPath?: string;
    illustrationRevisions?: IllustrationRevisionDto[];
    illustrationType?: IllustrationTypeDto;
    salesRepresentative?: GraphApiUserDto;
    supportRepresentative?: GraphApiUserDto;
    networkMember?: AccountDto;
    countries?: CountryDto[];
    networkMemberSubscribers?: string[];
}

export class IllustrationStageDto implements IIllustrationStageDto {
    id?: string;
    name?: string;

    constructor(data?: IIllustrationStageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): IllustrationStageDto {
        data = typeof data === 'object' ? data : {};
        let result = new IllustrationStageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IIllustrationStageDto {
    id?: string;
    name?: string;
}

export class IllustrationRevisionDto implements IIllustrationRevisionDto {
    id?: string;
    requesterEmail?: string | undefined;
    requestDate?: Date | undefined;
    finalizedSupportDate?: Date | undefined;
    poolable?: boolean | undefined;
    revisionNumber?: number;
    illustrationRevisionOptions?: IllustrationRevisionOptionDto[];
    illustrationRevisionAttachments?: IllustrationRevisionAttachmentDto[];

    constructor(data?: IIllustrationRevisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requesterEmail = _data["requesterEmail"];
            this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
            this.finalizedSupportDate = _data["finalizedSupportDate"] ? new Date(_data["finalizedSupportDate"].toString()) : <any>undefined;
            this.poolable = _data["poolable"];
            this.revisionNumber = _data["revisionNumber"];
            if (Array.isArray(_data["illustrationRevisionOptions"])) {
                this.illustrationRevisionOptions = [] as any;
                for (let item of _data["illustrationRevisionOptions"])
                    this.illustrationRevisionOptions!.push(IllustrationRevisionOptionDto.fromJS(item));
            }
            if (Array.isArray(_data["illustrationRevisionAttachments"])) {
                this.illustrationRevisionAttachments = [] as any;
                for (let item of _data["illustrationRevisionAttachments"])
                    this.illustrationRevisionAttachments!.push(IllustrationRevisionAttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IllustrationRevisionDto {
        data = typeof data === 'object' ? data : {};
        let result = new IllustrationRevisionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requesterEmail"] = this.requesterEmail;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["finalizedSupportDate"] = this.finalizedSupportDate ? this.finalizedSupportDate.toISOString() : <any>undefined;
        data["poolable"] = this.poolable;
        data["revisionNumber"] = this.revisionNumber;
        if (Array.isArray(this.illustrationRevisionOptions)) {
            data["illustrationRevisionOptions"] = [];
            for (let item of this.illustrationRevisionOptions)
                data["illustrationRevisionOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.illustrationRevisionAttachments)) {
            data["illustrationRevisionAttachments"] = [];
            for (let item of this.illustrationRevisionAttachments)
                data["illustrationRevisionAttachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIllustrationRevisionDto {
    id?: string;
    requesterEmail?: string | undefined;
    requestDate?: Date | undefined;
    finalizedSupportDate?: Date | undefined;
    poolable?: boolean | undefined;
    revisionNumber?: number;
    illustrationRevisionOptions?: IllustrationRevisionOptionDto[];
    illustrationRevisionAttachments?: IllustrationRevisionAttachmentDto[];
}

export class IllustrationRevisionOptionDto implements IIllustrationRevisionOptionDto {
    id?: string;
    sentToSalesRepresentativeBy?: string;
    sentToSalesRepresentativeDate?: Date;
    sentToNetworkMemberBy?: string;
    sentToNetworkMemberDate?: Date;
    sentToClientBy?: string;
    sentToClientDate?: Date;
    deleted?: boolean | undefined;
    sentFinalToRd?: string;
    sentFinalToRdDate?: Date;
    calcOpportunityId?: string;
    assignedOpportunityIds?: string;
    wordMPPPath?: string;
    pdfmppPath?: string;
    pdfmppName?: string;
    pdflocPath?: string;
    pdflocName?: string;
    optionGeneralOutput?: OptionGeneralOutputDto;

    constructor(data?: IIllustrationRevisionOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sentToSalesRepresentativeBy = _data["sentToSalesRepresentativeBy"];
            this.sentToSalesRepresentativeDate = _data["sentToSalesRepresentativeDate"] ? new Date(_data["sentToSalesRepresentativeDate"].toString()) : <any>undefined;
            this.sentToNetworkMemberBy = _data["sentToNetworkMemberBy"];
            this.sentToNetworkMemberDate = _data["sentToNetworkMemberDate"] ? new Date(_data["sentToNetworkMemberDate"].toString()) : <any>undefined;
            this.sentToClientBy = _data["sentToClientBy"];
            this.sentToClientDate = _data["sentToClientDate"] ? new Date(_data["sentToClientDate"].toString()) : <any>undefined;
            this.deleted = _data["deleted"];
            this.sentFinalToRd = _data["sentFinalToRd"];
            this.sentFinalToRdDate = _data["sentFinalToRdDate"] ? new Date(_data["sentFinalToRdDate"].toString()) : <any>undefined;
            this.calcOpportunityId = _data["calcOpportunityId"];
            this.assignedOpportunityIds = _data["assignedOpportunityIds"];
            this.wordMPPPath = _data["wordMPPPath"];
            this.pdfmppPath = _data["pdfmppPath"];
            this.pdfmppName = _data["pdfmppName"];
            this.pdflocPath = _data["pdflocPath"];
            this.pdflocName = _data["pdflocName"];
            this.optionGeneralOutput = _data["optionGeneralOutput"] ? OptionGeneralOutputDto.fromJS(_data["optionGeneralOutput"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IllustrationRevisionOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new IllustrationRevisionOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sentToSalesRepresentativeBy"] = this.sentToSalesRepresentativeBy;
        data["sentToSalesRepresentativeDate"] = this.sentToSalesRepresentativeDate ? this.sentToSalesRepresentativeDate.toISOString() : <any>undefined;
        data["sentToNetworkMemberBy"] = this.sentToNetworkMemberBy;
        data["sentToNetworkMemberDate"] = this.sentToNetworkMemberDate ? this.sentToNetworkMemberDate.toISOString() : <any>undefined;
        data["sentToClientBy"] = this.sentToClientBy;
        data["sentToClientDate"] = this.sentToClientDate ? this.sentToClientDate.toISOString() : <any>undefined;
        data["deleted"] = this.deleted;
        data["sentFinalToRd"] = this.sentFinalToRd;
        data["sentFinalToRdDate"] = this.sentFinalToRdDate ? this.sentFinalToRdDate.toISOString() : <any>undefined;
        data["calcOpportunityId"] = this.calcOpportunityId;
        data["assignedOpportunityIds"] = this.assignedOpportunityIds;
        data["wordMPPPath"] = this.wordMPPPath;
        data["pdfmppPath"] = this.pdfmppPath;
        data["pdfmppName"] = this.pdfmppName;
        data["pdflocPath"] = this.pdflocPath;
        data["pdflocName"] = this.pdflocName;
        data["optionGeneralOutput"] = this.optionGeneralOutput ? this.optionGeneralOutput.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIllustrationRevisionOptionDto {
    id?: string;
    sentToSalesRepresentativeBy?: string;
    sentToSalesRepresentativeDate?: Date;
    sentToNetworkMemberBy?: string;
    sentToNetworkMemberDate?: Date;
    sentToClientBy?: string;
    sentToClientDate?: Date;
    deleted?: boolean | undefined;
    sentFinalToRd?: string;
    sentFinalToRdDate?: Date;
    calcOpportunityId?: string;
    assignedOpportunityIds?: string;
    wordMPPPath?: string;
    pdfmppPath?: string;
    pdfmppName?: string;
    pdflocPath?: string;
    pdflocName?: string;
    optionGeneralOutput?: OptionGeneralOutputDto;
}

export class OptionGeneralOutputDto implements IOptionGeneralOutputDto {
    id?: string;
    poolingSystem?: string;

    constructor(data?: IOptionGeneralOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.poolingSystem = _data["poolingSystem"];
        }
    }

    static fromJS(data: any): OptionGeneralOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new OptionGeneralOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["poolingSystem"] = this.poolingSystem;
        return data;
    }
}

export interface IOptionGeneralOutputDto {
    id?: string;
    poolingSystem?: string;
}

export class IllustrationRevisionAttachmentDto implements IIllustrationRevisionAttachmentDto {
    id?: string;
    fileName?: string;
    filePath?: string;
    illustrationRevisionId?: string;
    opportunityId?: string;
    createdDate?: Date;

    constructor(data?: IIllustrationRevisionAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.filePath = _data["filePath"];
            this.illustrationRevisionId = _data["illustrationRevisionId"];
            this.opportunityId = _data["opportunityId"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IllustrationRevisionAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new IllustrationRevisionAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["filePath"] = this.filePath;
        data["illustrationRevisionId"] = this.illustrationRevisionId;
        data["opportunityId"] = this.opportunityId;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IIllustrationRevisionAttachmentDto {
    id?: string;
    fileName?: string;
    filePath?: string;
    illustrationRevisionId?: string;
    opportunityId?: string;
    createdDate?: Date;
}

export class IllustrationTypeDto implements IIllustrationTypeDto {
    id?: string;
    name?: string;

    constructor(data?: IIllustrationTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): IllustrationTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new IllustrationTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IIllustrationTypeDto {
    id?: string;
    name?: string;
}

export class GraphApiUserDto implements IGraphApiUserDto {
    id?: string;
    displayName?: string;
    mail?: string;

    constructor(data?: IGraphApiUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.mail = _data["mail"];
        }
    }

    static fromJS(data: any): GraphApiUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new GraphApiUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["mail"] = this.mail;
        return data;
    }
}

export interface IGraphApiUserDto {
    id?: string;
    displayName?: string;
    mail?: string;
}

export class CreateIllustrationCommand implements ICreateIllustrationCommand {
    clientId?: string | undefined;
    clientName?: string | undefined;
    countriesId?: string[];
    files?: CustomFile[];
    networkMemberId?: string;
    accountRepresentativeEmail?: string | undefined;
    regionalDirectorEmail?: string | undefined;
    accountRepresentativeId?: string | undefined;
    regionalDirectorId?: string | undefined;

    constructor(data?: ICreateIllustrationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            if (Array.isArray(_data["countriesId"])) {
                this.countriesId = [] as any;
                for (let item of _data["countriesId"])
                    this.countriesId!.push(item);
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(CustomFile.fromJS(item));
            }
            this.networkMemberId = _data["networkMemberId"];
            this.accountRepresentativeEmail = _data["accountRepresentativeEmail"];
            this.regionalDirectorEmail = _data["regionalDirectorEmail"];
            this.accountRepresentativeId = _data["accountRepresentativeId"];
            this.regionalDirectorId = _data["regionalDirectorId"];
        }
    }

    static fromJS(data: any): CreateIllustrationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIllustrationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        if (Array.isArray(this.countriesId)) {
            data["countriesId"] = [];
            for (let item of this.countriesId)
                data["countriesId"].push(item);
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["networkMemberId"] = this.networkMemberId;
        data["accountRepresentativeEmail"] = this.accountRepresentativeEmail;
        data["regionalDirectorEmail"] = this.regionalDirectorEmail;
        data["accountRepresentativeId"] = this.accountRepresentativeId;
        data["regionalDirectorId"] = this.regionalDirectorId;
        return data;
    }
}

export interface ICreateIllustrationCommand {
    clientId?: string | undefined;
    clientName?: string | undefined;
    countriesId?: string[];
    files?: CustomFile[];
    networkMemberId?: string;
    accountRepresentativeEmail?: string | undefined;
    regionalDirectorEmail?: string | undefined;
    accountRepresentativeId?: string | undefined;
    regionalDirectorId?: string | undefined;
}

export class CustomFile implements ICustomFile {
    file?: string;
    fileName?: string;

    constructor(data?: ICustomFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): CustomFile {
        data = typeof data === 'object' ? data : {};
        let result = new CustomFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface ICustomFile {
    file?: string;
    fileName?: string;
}

export class RejectIllustrationCommand implements IRejectIllustrationCommand {
    accountId?: string | undefined;
    opportunityId?: string;
    comments?: string[];
    userEmailAddress?: string;
    securityContext?: string;
    files?: CustomFile[];

    constructor(data?: IRejectIllustrationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.opportunityId = _data["opportunityId"];
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(item);
            }
            this.userEmailAddress = _data["userEmailAddress"];
            this.securityContext = _data["securityContext"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(CustomFile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RejectIllustrationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RejectIllustrationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["opportunityId"] = this.opportunityId;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item);
        }
        data["userEmailAddress"] = this.userEmailAddress;
        data["securityContext"] = this.securityContext;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRejectIllustrationCommand {
    accountId?: string | undefined;
    opportunityId?: string;
    comments?: string[];
    userEmailAddress?: string;
    securityContext?: string;
    files?: CustomFile[];
}

export class OpportunityDto implements IOpportunityDto {
    id?: string;
    description?: string;
    oppAccName?: string;
    status?: string;
    type?: string;
    win?: string;
    closed?: string;
    currentStep?: string;
    currentStepDate?: Date;
    reason?: string;
    createDate?: Date;
    countryIso2Code?: string;
    opportunityX?: OpportunityXDto;

    constructor(data?: IOpportunityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.oppAccName = _data["oppAccName"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.win = _data["win"];
            this.closed = _data["closed"];
            this.currentStep = _data["currentStep"];
            this.currentStepDate = _data["currentStepDate"] ? new Date(_data["currentStepDate"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.countryIso2Code = _data["countryIso2Code"];
            this.opportunityX = _data["opportunityX"] ? OpportunityXDto.fromJS(_data["opportunityX"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OpportunityDto {
        data = typeof data === 'object' ? data : {};
        let result = new OpportunityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["oppAccName"] = this.oppAccName;
        data["status"] = this.status;
        data["type"] = this.type;
        data["win"] = this.win;
        data["closed"] = this.closed;
        data["currentStep"] = this.currentStep;
        data["currentStepDate"] = this.currentStepDate ? this.currentStepDate.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["countryIso2Code"] = this.countryIso2Code;
        data["opportunityX"] = this.opportunityX ? this.opportunityX.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOpportunityDto {
    id?: string;
    description?: string;
    oppAccName?: string;
    status?: string;
    type?: string;
    win?: string;
    closed?: string;
    currentStep?: string;
    currentStepDate?: Date;
    reason?: string;
    createDate?: Date;
    countryIso2Code?: string;
    opportunityX?: OpportunityXDto;
}

export class OpportunityXDto implements IOpportunityXDto {
    opportunityXId?: string;
    category?: string;
    country?: string;
    productcode?: string;
    businessplan?: string;

    constructor(data?: IOpportunityXDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.opportunityXId = _data["opportunityXId"];
            this.category = _data["category"];
            this.country = _data["country"];
            this.productcode = _data["productcode"];
            this.businessplan = _data["businessplan"];
        }
    }

    static fromJS(data: any): OpportunityXDto {
        data = typeof data === 'object' ? data : {};
        let result = new OpportunityXDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["opportunityXId"] = this.opportunityXId;
        data["category"] = this.category;
        data["country"] = this.country;
        data["productcode"] = this.productcode;
        data["businessplan"] = this.businessplan;
        return data;
    }
}

export interface IOpportunityXDto {
    opportunityXId?: string;
    category?: string;
    country?: string;
    productcode?: string;
    businessplan?: string;
}

export class UpdateQuestionCommand implements IUpdateQuestionCommand {
    categoryId?: string;
    question?: Question;

    constructor(data?: IUpdateQuestionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.question = _data["question"] ? Question.fromJS(_data["question"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateQuestionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuestionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["question"] = this.question ? this.question.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateQuestionCommand {
    categoryId?: string;
    question?: Question;
}

export class EmbedParamsDTO implements IEmbedParamsDTO {
    type?: string;
    embedReport?: EmbedReportDTO[];
    embedToken?: EmbedToken;

    constructor(data?: IEmbedParamsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["embedReport"])) {
                this.embedReport = [] as any;
                for (let item of _data["embedReport"])
                    this.embedReport!.push(EmbedReportDTO.fromJS(item));
            }
            this.embedToken = _data["embedToken"] ? EmbedToken.fromJS(_data["embedToken"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmbedParamsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmbedParamsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.embedReport)) {
            data["embedReport"] = [];
            for (let item of this.embedReport)
                data["embedReport"].push(item.toJSON());
        }
        data["embedToken"] = this.embedToken ? this.embedToken.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmbedParamsDTO {
    type?: string;
    embedReport?: EmbedReportDTO[];
    embedToken?: EmbedToken;
}

export class EmbedReportDTO implements IEmbedReportDTO {
    reportId?: string;
    reportName?: string;
    embedUrl?: string;

    constructor(data?: IEmbedReportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.reportName = _data["reportName"];
            this.embedUrl = _data["embedUrl"];
        }
    }

    static fromJS(data: any): EmbedReportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmbedReportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["reportName"] = this.reportName;
        data["embedUrl"] = this.embedUrl;
        return data;
    }
}

export interface IEmbedReportDTO {
    reportId?: string;
    reportName?: string;
    embedUrl?: string;
}

export class EmbedToken implements IEmbedToken {
    token?: string | undefined;
    tokenId?: string;
    expiration?: Date;

    constructor(data?: IEmbedToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.tokenId = _data["tokenId"];
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmbedToken {
        data = typeof data === 'object' ? data : {};
        let result = new EmbedToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["tokenId"] = this.tokenId;
        data["expiration"] = this.expiration ? this.expiration.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEmbedToken {
    token?: string | undefined;
    tokenId?: string;
    expiration?: Date;
}

export class PowerBiReportDetails implements IPowerBiReportDetails {
    reportName?: string;
    reportId?: string;
    roles?: string[];

    constructor(data?: IPowerBiReportDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportName = _data["reportName"];
            this.reportId = _data["reportId"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): PowerBiReportDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PowerBiReportDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportName"] = this.reportName;
        data["reportId"] = this.reportId;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IPowerBiReportDetails {
    reportName?: string;
    reportId?: string;
    roles?: string[];
}

export class ReportAccessRoles implements IReportAccessRoles {
    reportName?: string;
    reportRoles?: string[];

    constructor(data?: IReportAccessRoles) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportName = _data["reportName"];
            if (Array.isArray(_data["reportRoles"])) {
                this.reportRoles = [] as any;
                for (let item of _data["reportRoles"])
                    this.reportRoles!.push(item);
            }
        }
    }

    static fromJS(data: any): ReportAccessRoles {
        data = typeof data === 'object' ? data : {};
        let result = new ReportAccessRoles();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportName"] = this.reportName;
        if (Array.isArray(this.reportRoles)) {
            data["reportRoles"] = [];
            for (let item of this.reportRoles)
                data["reportRoles"].push(item);
        }
        return data;
    }
}

export interface IReportAccessRoles {
    reportName?: string;
    reportRoles?: string[];
}

export enum SettingCategory {
    Jobs = 0,
    Tasks = 1,
    PowerBiAccessRoles = 2,
}

export class NewPowerBiReportSettings implements INewPowerBiReportSettings {
    name?: string;
    description?: string;
    value?: ReportAccessRoles;

    constructor(data?: INewPowerBiReportSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.value = _data["value"] ? ReportAccessRoles.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NewPowerBiReportSettings {
        data = typeof data === 'object' ? data : {};
        let result = new NewPowerBiReportSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface INewPowerBiReportSettings {
    name?: string;
    description?: string;
    value?: ReportAccessRoles;
}

export class UserActivityDto implements IUserActivityDto {
    id?: string;
    userAction?: string;
    userId?: string;
    email?: string;
    path?: string | undefined;
    taskId?: string | undefined;
    created?: Date;
    processId?: string;

    constructor(data?: IUserActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userAction = _data["userAction"];
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.path = _data["path"];
            this.taskId = _data["taskId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.processId = _data["processId"];
        }
    }

    static fromJS(data: any): UserActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userAction"] = this.userAction;
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["path"] = this.path;
        data["taskId"] = this.taskId;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["processId"] = this.processId;
        return data;
    }
}

export interface IUserActivityDto {
    id?: string;
    userAction?: string;
    userId?: string;
    email?: string;
    path?: string | undefined;
    taskId?: string | undefined;
    created?: Date;
    processId?: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}